{
  "account.account": "Profilo e sicurezza",
  "account.accountDeleted": "Il tuo account è stato cancellato con successo.",
  "account.accountDescription": "Nome, password, eliminazione dell'account",
  "account.accountSection": "Account",
  "account.changeEmail": "Cambia email",
  "account.changePassword": "Cambia password",
  "account.currentPassword": "Password attuale",
  "account.dangerZone": "Zona critica",
  "account.deleteAccount": "Elimina l'account",
  "account.deleteAccountConfirmation": "Sei sicuro di voler cancellare l'account? Questa azione è irreversibile.",
  "account.deleteAccountDescription": "Questa azione elimina il tuo account e tutte le tue informazioni. Non si può tornare indietro.",
  "account.emailChange": "Cambia indirizzo email",
  "account.emailChangeConfirmation": "Conferma cambio email",
  "account.emailChangeFailure": "Il link per il cambio email non è valido o è scaduto.",
  "account.emailChangeIntro": "Inserisci il tuo nuovo indirizzo email e la password attuale. Invieremo un link al nuovo indirizzo: la tua email cambierà solo dopo che lo avrai aperto.",
  "account.emailChangeSuccess": "La tua email è stata cambiata con successo in {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Il tuo indirizzo email è stato cambiato con successo.",
  "account.emailChangeVerificationSent": "Un'email di verifica è stata inviata al tuo nuovo indirizzo email. Controlla la tua casella di posta e clicca sul link per confermare il cambio.",
  "account.manageAccount": "Gestisci account",
  "account.newEmailAddress": "Nuovo indirizzo email",
  "account.newPassword": "Nuova password",
  "account.newPasswordAgain": "Ripeti la nuova password",
  "account.oldPassword": "Vecchia password",
  "account.passwordChange": "Modifica password",
  "account.passwordChangeDescription": "Mantieni sicuro il tuo account",
  "account.passwordUpdated": "Password aggiornata con successo.",
  "account.profile": "Profilo",
  "account.profileUpdated": "Profilo aggiornato correttamente.",
  "account.signedInAs": "Accesso effettuato come",
  "account.updateYourProfile": "Aggiorna il tuo profilo",
  "account.updateYourProfileDescription": "Nome e preferenze di visualizzazione",
  "addons.accountOnHold": "La connessione del tuo account è scaduta. Riconnettiti per riprendere gli aggiornamenti dei dati.",
  "addons.accountOnHoldTitle": "Account sospeso",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Crea e recupera la tua chiave API da questo link",
  "addons.ambientWeatherDescription": "Stazioni meteorologiche Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Chiave API",
  "addons.applicationKey": "Chiave applicazione",
  "addons.availableServices": "Disponibili",
  "addons.cannotDisconnectLastAccount": "Non è possibile scollegare l'unico metodo di accesso. Aggiungi prima un altro metodo di accesso.",
  "addons.connect": "Connetti",
  "addons.connected": "Collegato",
  "addons.connectedAccounts": "Account collegati",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Caricamento degli account collegati…",
  "addons.connectedServices": "Collegati",
  "addons.connectedSince": "Collegato dal {date}",
  "addons.connectionSection": "Connessione",
  "addons.connectionSuccess": "Account {provider} collegato con successo",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "Chiave API V2",
  "addons.davisDescription": "Stazioni meteo Davis (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Recupera le tue chiavi API V2 da questo link",
  "addons.disconnect": "Disconnetti",
  "addons.disconnectConfirmation": "Sei sicuro di voler scollegare il tuo account {provider}?",
  "addons.disconnectEnergyConfirmation": "SmartMixin smetterà di sincronizzare Netatmo Energy e rimuoverà le tue case da SmartMixin. Il tuo account Netatmo e i tuoi dispositivi non vengono modificati.",
  "addons.disconnectEnergyDescription": "Interrompe la sincronizzazione e rimuove le tue case da SmartMixin.",
  "addons.disconnectionSuccess": "Account {provider} scollegato con successo",
  "addons.disconnectProviderDescription": "Interrompe la sincronizzazione ed elimina le stazioni di questo servizio e i loro dati storici.",
  "addons.disconnectServiceConfirmation": "SmartMixin smetterà di sincronizzare {provider} ed eliminerà le stazioni di questo servizio e tutti i loro dati storici. Il tuo account {provider} non viene modificato.",
  "addons.disconnectServiceTitle": "Disconnettere {provider}?",
  "addons.ecowittCreateAndRetrieveKeys": "Crea e recupera sia una chiave API che una chiave dell'applicazione da questo collegamento",
  "addons.ecowittDescription": "Ecowitt fornisce stazioni meteorologiche Wi-Fi professionali, termometri esterni e interni wireless, monitor dell'umidità, pluviometri ad alta precisione, monitor della qualità dell'aria e altro ancora.",
  "addons.helpLink": "Come connettere {provider}",
  "addons.integrationsSection": "Integrazioni",
  "addons.myAcuriteAccountOnHold": "Il tuo account è stato sospeso. Inserisci la tua password per ricollegare il tuo account",
  "addons.myAcuriteDescription": "AcuRite è il marchio di stazioni meteorologiche numero 1 nel Nord America. In qualità di leader nella tecnologia del tempo, della temperatura e del meteo, AcuRite ti fornisce informazioni dettagliate sul tuo ambiente interno ed esterno in modo che tu possa pianificare la tua giornata con sicurezza.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Usa il tuo termostato Netatmo per cambiare la temperatura della tua casa, dal tuo letto o dall'altra parte del mondo.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "La tua stazione meteo personale a casa",
  "addons.notConnected": "Non collegato",
  "addons.or": "o",
  "addons.providerAccountDisconnected": "La connessione al tuo servizio meteo è scaduta. Riconnettiti per riprendere gli aggiornamenti dei dati.",
  "addons.reconnect": "Riconnetti",
  "addons.socialConnectionsIntro": "Collega i tuoi account social per un accesso rapido. Puoi collegare o scollegare gli account in qualsiasi momento.",
  "addons.weatherflowAccessToken": "Token di accesso",
  "addons.weatherflowCreateToken": "Crea e recupera il tuo token da questo link",
  "addons.weatherflowTempestDescription": "Stazione meteo Tempest con anemometro e pluviometro integrati",
  "addons.weatherServices": "Servizi meteo",
  "addons.weatherServicesConnected": "{count, plural, =0 {Nessun servizio connesso} one {# servizio connesso} other {# servizi connessi}}",
  "addons.weatherServicesDescription": "Collega Netatmo, Davis, Weatherflow e altro",
  "addons.wundergroundApiKey": "Chiave API",
  "addons.wundergroundDescription": "Weather Underground è una comunità globale di persone che collega i dati provenienti da sensori ambientali come stazioni meteorologiche e monitor della qualità dell'aria in modo da poter fornire i dati ricchi e iperlocali di cui hai bisogno per alimentare le tue passioni",
  "addons.wundergroundRemoveStationDescription": "La stazione esce dal tuo account SmartMixin. A meno che un altro account SmartMixin non l'abbia aggiunta, la stazione e lo storico che SmartMixin ha registrato per essa vengono eliminati. Su Weather Underground non cambia nulla.",
  "addons.wundergroundRemoveStationTitle": "Eliminare {station}?",
  "addons.wundergroundRetrieveApiKey": "Recupera la tua chiave API da questo link",
  "addons.wundergroundStationId": "ID stazione",
  "airQuality.adviceActivityGood": "Giornata ideale per le attività all'aperto",
  "airQuality.adviceActivityHazardous": "Evita ogni attività fisica all'aperto",
  "airQuality.adviceActivityLabel": "Attività fisica",
  "airQuality.adviceActivityModerate": "Buona giornata per le attività all'aperto",
  "airQuality.adviceActivitySensitive": "Valuta attività all'aperto più brevi e meno intense",
  "airQuality.adviceActivityUnhealthy": "Riduci le attività lunghe o intense e fai più pause",
  "airQuality.adviceActivityVeryUnhealthy": "Evita le attività lunghe o intense; valuta di spostarle al chiuso",
  "airQuality.adviceGroupsGood": "Nessuna precauzione particolare",
  "airQuality.adviceGroupsHazardous": "Resta al chiuso e limita l'attività",
  "airQuality.adviceGroupsLabel": "Gruppi sensibili",
  "airQuality.adviceGroupsModerate": "Persone particolarmente sensibili: attività più brevi e meno intense",
  "airQuality.adviceGroupsSensitive": "Attività all'aperto più brevi e meno intense, con più pause",
  "airQuality.adviceGroupsUnhealthy": "Evita le attività lunghe o intense all'aperto; valuta di spostarle al chiuso",
  "airQuality.adviceGroupsVeryUnhealthy": "Evita ogni attività fisica all'aperto; rimandala o spostala al chiuso",
  "airQuality.adviceTimingLabel": "Quando uscire",
  "airQuality.adviceTimingMorning": "Meglio al mattino: l'ozono è più basso",
  "airQuality.airQuality": "Qualità dell'aria",
  "airQuality.airQualityIndex": "Indice di qualità dell'aria",
  "airQuality.aqiForecast": "Previsioni qualità dell'aria",
  "airQuality.co2Fresh": "Fresca",
  "airQuality.co2GettingStale": "Leggermente viziata",
  "airQuality.co2Stale": "Viziata",
  "airQuality.dailyForecast": "Previsioni giornaliere",
  "airQuality.dominantPollutant": "Inquinante dominante",
  "airQuality.expectedPeak": "Picco previsto",
  "airQuality.good": "Buona",
  "airQuality.goodDescription": "La qualità dell'aria è considerata soddisfacente e l'inquinamento atmosferico presenta un rischio minimo o nullo",
  "airQuality.hazardous": "Pericolosa",
  "airQuality.hazardousDescription": "Allerta sanitaria: tutti possono avere effetti più gravi sulla salute",
  "airQuality.indoorAirQuality": "Qualità aria interna",
  "airQuality.moderate": "Moderata",
  "airQuality.moderateDescription": "La qualità dell'aria è accettabile. Tuttavia, per alcuni inquinanti, può esserci un moderato problema di salute per un numero molto ridotto di persone che sono più sensibili all'inquinamento atmosferico.",
  "airQuality.noForecastForLocation": "Nessuna previsione della qualità dell'aria disponibile per questa località.",
  "airQuality.now": "Adesso",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Inquinanti",
  "airQuality.recommendations": "Raccomandazioni",
  "airQuality.sensitiveUnhealthy": "Malsana per i gruppi sensibili",
  "airQuality.sensitiveUnhealthyDescription": "Le persone più sensibili all'inquinamento atmosferico possono avere effetti sulla salute. È improbabile che il pubblico in generale ne risenta.",
  "airQuality.subIndex": "Sotto-indice AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Capire l'indice",
  "airQuality.unhealthy": "Malsana",
  "airQuality.unhealthyDescription": "Tutti possono iniziare a risentire di effetti sulla salute. Le persone più sensibili all'inquinamento atmosferico possono avere effetti sulla salute più gravi.",
  "airQuality.veryUnhealthy": "Molto malsana",
  "airQuality.veryUnhealthyDescription": "Avvertenze sanitarie di condizione di emergenza. L'intera popolazione ha maggiore probabilità di essere colpita.",
  "alerts.addAlert": "Aggiungi un avviso",
  "alerts.addCondition": "Aggiungi condizione",
  "alerts.alertAdded": "Avviso aggiunto con successo",
  "alerts.alertAuthorizationNotice": "Gli avvisi possono funzionare solo se si consente a SmartMixin di mostrare le notifiche",
  "alerts.alertDeleted": "Avviso eliminato con successo",
  "alerts.alertName": "Nome dell'avviso",
  "alerts.alertWhen": "Voglio essere avvisato quando",
  "alerts.aqiGreaterThan": "AQI maggiore di",
  "alerts.aqiGreaterThanThreshold": "AQI superiore al valore limite di {value}{unit}",
  "alerts.aqiLessThan": "AQI minore di",
  "alerts.aqiLessThanThreshold": "AQI inferiore al valore limite di {value}{unit}",
  "alerts.atLeastOneCondition": "Devi aggiungere almeno una condizione",
  "alerts.co2GreaterThan": "CO2 maggiore di",
  "alerts.co2GreaterThanThreshold": "CO2 superiore al valore limite di {value}{unit}",
  "alerts.co2LessThan": "CO2 minore di",
  "alerts.co2LessThanThreshold": "CO2 inferiore al valore limite di {value}{unit}",
  "alerts.conditions": "Condizioni",
  "alerts.conditionsDroppedOnStationChange": "Non supportate da questa stazione e rimosse: {conditions}",
  "alerts.createAlert": "Crea avviso",
  "alerts.dailyPrecipitationGreaterThan": "Precipitazione giornaliera superiore a",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Precipitazione giornaliera superiore alla soglia di {value}{unit}",
  "alerts.deleteAlert": "Elimina avviso",
  "alerts.editAlert": "Modifica avviso",
  "alerts.editCondition": "Modifica condizione",
  "alerts.gustSpeedGreaterThan": "Raffica maggiore di",
  "alerts.gustSpeedGreaterThanThreshold": "Raffica superiore al valore limite di {value}{unit}",
  "alerts.gustSpeedLessThan": "Raffica minore di",
  "alerts.gustSpeedLessThanThreshold": "Raffica inferiore al valore limite di {value}{unit}",
  "alerts.heatIndexGreaterThan": "Indice di calore maggiore di",
  "alerts.heatIndexGreaterThanThreshold": "Indice di calore superiore al valore limite di {value}{unit}",
  "alerts.heatIndexLessThan": "Indice di calore minore di",
  "alerts.heatIndexLessThanThreshold": "Indice di calore inferiore al valore limite di {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex maggiore di",
  "alerts.humidexGreaterThanThreshold": "Humidex superiore al valore limite di {value}{unit}",
  "alerts.humidexLessThan": "Humidex minore di",
  "alerts.humidexLessThanThreshold": "Humidex inferiore al valore limite di {value}{unit}",
  "alerts.humidityGreaterThan": "Umidità maggiore di",
  "alerts.humidityGreaterThanThreshold": "Umidità superiore al valore limite di {value}{unit}",
  "alerts.humidityLessThan": "Umidità minore di",
  "alerts.humidityLessThanThreshold": "Umidità inferiore al valore limite di {value}{unit}",
  "alerts.inProgress": "In corso",
  "alerts.leafWetnessGreaterThan": "Umidità fogliare superiore a",
  "alerts.leafWetnessGreaterThanThreshold": "Umidità fogliare superiore al valore limite di {value}{unit}",
  "alerts.leafWetnessLessThan": "Umidità fogliare inferiore a",
  "alerts.leafWetnessLessThanThreshold": "Umidità fogliare inferiore al valore limite di {value}{unit}",
  "alerts.myAlerts": "I miei avvisi",
  "alerts.noConfiguredAlert": "Non hai ancora un avviso, aggiungine uno",
  "alerts.noiseGreaterThan": "Rumore maggiore di",
  "alerts.noiseGreaterThanThreshold": "Rumore superiore al valore limite di {value}{unit}",
  "alerts.noiseLessThan": "Rumore minore di",
  "alerts.noiseLessThanThreshold": "Rumore inferiore al valore limite di {value}{unit}",
  "alerts.noteOnConditions": "Tieni presente che l'avviso viene attivato quando tutte le condizioni aggiunte sono vere",
  "alerts.noTriggerHistory": "Questo avviso non è ancora stato attivato.",
  "alerts.pm10GreaterThan": "PM 10 maggiore di",
  "alerts.pm10GreaterThanThreshold": "PM 10 superiore al valore limite di {value}{unit}",
  "alerts.pm10LessThan": "PM 10 minore di",
  "alerts.pm10LessThanThreshold": "PM 10 inferiore al valore limite di {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 maggiore di",
  "alerts.pm1GreaterThanThreshold": "PM 1 superiore al valore limite di {value}{unit}",
  "alerts.pm1LessThan": "PM 1 minore di",
  "alerts.pm1LessThanThreshold": "PM 1 inferiore al valore limite di {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 maggiore di",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 superiore al valore limite di {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 minore di",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 inferiore al valore limite di {value}{unit}",
  "alerts.postStormSummary": "Riepilogo del temporale",
  "alerts.postStormSynopsisHelper": "Riceverai una notifica di riepilogo al termine di ogni temporale.",
  "alerts.postStormSynopsisSoleCondition": "Un riepilogo del temporale non può essere combinato con altre condizioni.",
  "alerts.precipitationGreaterThan": "Precipitazione oraria superiore a",
  "alerts.precipitationGreaterThanThreshold": "Precipitazione oraria superiore alla soglia di {value}{unit}",
  "alerts.pressureGreaterThan": "Pressione maggiore di",
  "alerts.pressureGreaterThanThreshold": "Pressione superiore al valore limite di {value}{unit}",
  "alerts.pressureLessThan": "Pressione minore di",
  "alerts.pressureLessThanThreshold": "Pressione inferiore al valore limite di {value}{unit}",
  "alerts.rainRateGreaterThan": "Intensità di pioggia superiore a",
  "alerts.rainRateGreaterThanThreshold": "Intensità di pioggia superiore alla soglia di {value}{unit}",
  "alerts.sensorNotReporting": "Questo sensore non sta inviando dati al momento. L'avviso riprenderà quando tornerà a farlo.",
  "alerts.soilMoistureGreaterThan": "Umidità del suolo superiore a",
  "alerts.soilMoistureGreaterThanThreshold": "Umidità del suolo superiore al valore limite di {value}{unit}",
  "alerts.soilMoistureLessThan": "Umidità del suolo inferiore a",
  "alerts.soilMoistureLessThanThreshold": "Umidità del suolo inferiore al valore limite di {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Radiazione solare maggiore di",
  "alerts.solarRadiationGreaterThanThreshold": "Radiazione solare superiore al valore limite di {value}{unit}",
  "alerts.solarRadiationLessThan": "Radiazione solare minore di",
  "alerts.solarRadiationLessThanThreshold": "Radiazione solare inferiore al valore limite di {value}{unit}",
  "alerts.stationNoLongerReports": "Questa stazione non invia più dati, quindi questo avviso non può attivarsi.",
  "alerts.stormChartUnavailable": "Lo storico della pioggia per questo temporale non è disponibile.",
  "alerts.stormDetail": "Riepilogo del temporale",
  "alerts.stormDuration": "Durata",
  "alerts.stormEnd": "Fine",
  "alerts.stormPeakRate": "Intensità massima di pioggia",
  "alerts.stormStart": "Inizio",
  "alerts.stormTotal": "Pioggia totale",
  "alerts.temperatureGreaterThan": "Temperatura maggiore di",
  "alerts.temperatureGreaterThanThreshold": "Temperatura superiore al valore limite di {value}{unit}",
  "alerts.temperatureLessThan": "Temperatura minore di",
  "alerts.temperatureLessThanThreshold": "Temperatura inferiore al valore limite di {value}{unit}",
  "alerts.thresholdOutOfRange": "Deve essere compreso tra {min} e {max}",
  "alerts.thswGreaterThan": "THSW maggiore di",
  "alerts.thswGreaterThanThreshold": "THSW superiore al valore limite di {value}{unit}",
  "alerts.thswLessThan": "THSW minore di",
  "alerts.thswLessThanThreshold": "THSW inferiore al valore limite di {value}{unit}",
  "alerts.thwGreaterThan": "THW maggiore di",
  "alerts.thwGreaterThanThreshold": "THW superiore al valore limite di {value}{unit}",
  "alerts.thwLessThan": "THW minore di",
  "alerts.thwLessThanThreshold": "THW inferiore al valore limite di {value}{unit}",
  "alerts.triggerHistory": "Cronologia dell'avviso",
  "alerts.uvGreaterThan": "UV maggiore di",
  "alerts.uvGreaterThanThreshold": "UV superiore al valore limite di {value}{unit}",
  "alerts.uvLessThan": "UV minore di",
  "alerts.uvLessThanThreshold": "UV inferiore al valore limite di {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Visibilità superiore al valore limite di {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Visibilità inferiore al valore limite di {value}{unit}",
  "alerts.visiblityGreaterThan": "Visibilità maggiore di",
  "alerts.visiblityLessThan": "Visibilità minore di",
  "alerts.whichMeasure": "Per quale misurazione vuoi essere avvisato?",
  "alerts.whichModule": "Per quale modulo vorresti essere avvisato?",
  "alerts.whichSensor": "Per quale sensore vorresti essere avvisato?",
  "alerts.windChillGreaterThan": "Raffreddamento da vento maggiore di",
  "alerts.windChillGreaterThanThreshold": "Raffreddamento da vento superiore al valore limite di {value}{unit}",
  "alerts.windChillLessThan": "Raffreddamento da vento minore di",
  "alerts.windChillLessThanThreshold": "Raffreddamento da vento inferiore al valore limite di {value}{unit}",
  "alerts.windSpeedGreaterThan": "Vento maggiore di",
  "alerts.windSpeedGreaterThanThreshold": "Vento superiore al valore limite di {value}{unit}",
  "alerts.windSpeedLessThan": "Vento minore di",
  "alerts.windSpeedLessThanThreshold": "Vento inferiore al valore limite di {value}{unit}",
  "appUpdate.updateAvailable": "Aggiornamento disponibile",
  "appUpdate.updateAvailableOpenAppStore": "Tocca per aprire l'App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Tocca per aprire Google Play",
  "appUpdate.updateAvailableVersion": "Aggiornamento disponibile: v{version}",
  "appUpdate.upgradeRequiredAndroid": "È richiesto un aggiornamento della tua applicazione, vai su Google Play per eseguire l'aggiornamento.",
  "appUpdate.upgradeRequiredIos": "È richiesto un aggiornamento della tua applicazione, vai sull'App Store per eseguire l'aggiornamento.",
  "astral.aboveHorizonAllDay": "Sopra l’orizzonte tutto il giorno",
  "astral.aboveTheHorizon": "sopra l’orizzonte",
  "astral.apparentSize": "Diametro apparente",
  "astral.apparentSizeAcross": "{size} di diametro",
  "astral.astronomicalDawn": "Alba astronomica",
  "astral.astronomicalDusk": "Crepuscolo astronomico",
  "astral.belowHorizonAllDay": "Sotto l’orizzonte tutto il giorno",
  "astral.belowHorizonSince": "Sotto l’orizzonte dalle {time}",
  "astral.belowHorizonSinceOn": "Sotto l’orizzonte da {day} alle {time}",
  "astral.brightAllNight": "Luna luminosa tutta la notte — mai completamente buio",
  "astral.brightestMoment": "Momento più chiaro",
  "astral.civilDawn": "Alba civile",
  "astral.civilDusk": "Crepuscolo civile",
  "astral.darkSkyBetween": "Cielo buio {from} → {to}",
  "astral.darkSkyWindow": "Cielo buio {from} → {to} · {duration} senza Luna",
  "astral.dayLength": "Durata del giorno",
  "astral.daylightThroughTheYear": "Durata del giorno nell’anno",
  "astral.dayOfCycle": "giorno {day} di {total}",
  "astral.doesNotOccurToday": "Oggi non avviene",
  "astral.domeHint": "Trascina per scorrere la notte",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Sorgere del Sole più precoce",
  "astral.earliestSunset": "Tramonto più precoce",
  "astral.equinox": "Equinozio",
  "astral.equinoxIn": "Equinozio tra {days, plural, one {# giorno} other {# giorni}}",
  "astral.evening": "Sera",
  "astral.exactPhaseAt": "Esattamente alle {time}",
  "astral.firstQuarter": "Primo quarto",
  "astral.firstSunriseIn": "Primo sorgere del Sole tra {days, plural, one {# giorno} other {# giorni}}",
  "astral.firstSunsetIn": "Primo tramonto tra {days, plural, one {# giorno} other {# giorni}}",
  "astral.fullMoon": "Luna piena",
  "astral.goldenHourBegins": "Inizio dell’ora d’oro",
  "astral.goldenHourEnds": "Fine dell’ora d’oro",
  "astral.highestPoint": "Punto più alto",
  "astral.inDays": "tra {days, plural, one {# giorno} other {# giorni}}",
  "astral.lastQuarter": "Ultimo quarto",
  "astral.latestSunrise": "Sorgere del Sole più tardivo",
  "astral.latestSunset": "Tramonto più tardivo",
  "astral.litShort": "Illum.",
  "astral.longestDay": "Giorno più lungo",
  "astral.lowestPoint": "Punto più basso",
  "astral.maxAltitudeShort": "Max",
  "astral.midday": "Mezzogiorno",
  "astral.midnightSun": "Sole di mezzanotte",
  "astral.midnightSunPeriod": "Sole di mezzanotte",
  "astral.milestoneFootnotePolar": "Qui il sole non sorge né tramonta per {days, plural, one {# giorno} other {# giorni}} all’anno, quindi al posto dei consueti estremi di alba e tramonto l’elenco mostra quando ciò accade.",
  "astral.milestoneFootnoteTemperate": "Il tramonto più precoce e l’alba più tardiva non cadono nel giorno più corto — è l’equazione del tempo, non il solstizio, a fissare queste due date.",
  "astral.moon": "Luna",
  "astral.moonAltitude": "Altezza",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Distanza",
  "astral.moonlessFor": "{duration} senza Luna",
  "astral.moonPhases": "Fasi lunari",
  "astral.moonrise": "Sorgere della Luna",
  "astral.moonset": "Tramonto della Luna",
  "astral.moonUpAllNight": "La Luna è sopra l’orizzonte tutta la notte",
  "astral.moonWashesOutNight": "La Luna è sopra l’orizzonte dalle {rise} alle {set} e rischiara tutta la notte",
  "astral.morning": "Mattina",
  "astral.nauticalDawn": "Alba nautica",
  "astral.nauticalDusk": "Crepuscolo nautico",
  "astral.newMoon": "Luna nuova",
  "astral.nextDay": "+1 giorno",
  "astral.nextProperlyDarkNight": "Prossima notte davvero buia",
  "astral.nextRise": "prossimo sorgere alle {time}",
  "astral.nextRiseOn": "prossimo sorgere {day} alle {time}",
  "astral.nextSevenNights": "Le prossime sette notti",
  "astral.nightDate": "Data",
  "astral.noAstronomicalDarknessTonight": "Nessuna notte astronomica stanotte",
  "astral.noDarkNightAhead": "Nessuna nelle prossime due settimane",
  "astral.noStationLocation": "Posizione sconosciuta",
  "astral.noStationLocationDescription": "Questa stazione non ha una posizione registrata, quindi non è possibile calcolare il sole e la luna per essa.",
  "astral.noSunriseToday": "Oggi il Sole non sorge",
  "astral.nowAtBearing": "adesso {altitude} · azimut {direction}",
  "astral.observing": "Osservazione",
  "astral.ofDaylightLeft": "di luce rimanente",
  "astral.overTheNextThreeWeeks": "nelle prossime 3 settimane",
  "astral.percentLit": "{percent} illuminata",
  "astral.polarNight": "Notte polare",
  "astral.polarNightPeriod": "Notte polare",
  "astral.rightNow": "Adesso",
  "astral.riseShort": "Levata",
  "astral.setShort": "Tramonto",
  "astral.shortestDay": "Giorno più corto",
  "astral.solarNoon": "Mezzogiorno solare",
  "astral.solstice": "Solstizio",
  "astral.sunBelowHorizon": "Sole a {degrees}° sotto l’orizzonte",
  "astral.sunEvents": "Eventi solari",
  "astral.sunNeverDarkEnough": "Il Sole non scende mai 18° sotto l’orizzonte",
  "astral.sunNeverSets": "Il Sole non tramonta",
  "astral.sunrise": "Levata del sole",
  "astral.sunriseAndSunset": "Levata del sole e tramonto",
  "astral.sunriseAt": "Alba alle {time}",
  "astral.sunset": "Tramonto",
  "astral.sunsetAt": "Tramonto alle {time}",
  "astral.thisYearAtNorth": "Quest’anno a {degrees}° N",
  "astral.thisYearAtSouth": "Quest’anno a {degrees}° S",
  "astral.tonight": "Stanotte",
  "astral.twilightAllNight": "Crepuscolo tutta la notte — mai completamente buio",
  "astral.upFor": "{duration} sopra l’orizzonte",
  "astral.usableLight": "Luce utile",
  "astral.vsAverage": "{percent} rispetto alla media",
  "astral.vsYesterday": "rispetto a ieri",
  "astral.waningCrescent": "Luna calante",
  "astral.waningGibbous": "Luna gibbosa calante",
  "astral.waxingCrescent": "Luna crescente",
  "astral.waxingGibbous": "Luna gibbosa crescente",
  "astral.whereToLook": "Dove guardare",
  "astral.withoutTheMoon": "{duration} senza Luna",
  "auth.alreadyHaveAccount": "Hai già un account?",
  "auth.authContainerTagline": "La tua dashboard meteo personale. Collega le tue stazioni e ottieni dati in tempo reale a portata di mano.",
  "auth.backToLogin": "Torna al login",
  "auth.checkYourEmail": "Controlla la tua email",
  "auth.continueWithApple": "Continua con Apple",
  "auth.continueWithFacebook": "Continua con Facebook",
  "auth.continueWithGoogle": "Continua con Google",
  "auth.email": "Indirizzo email",
  "auth.emailRequiredLoginFacebook": "Per accedere con Facebook è necessario fornire l'autorizzazione tramite Email",
  "auth.emailVerification": "Verifica email",
  "auth.emailVerificationFailure": "Si è verificato un problema con la verifica dell'email.",
  "auth.emailVerificationSuccess": "La tua email è stata verificata con successo.",
  "auth.firstName": "Nome",
  "auth.forgotPassword": "Password dimenticata",
  "auth.forgotPasswordSubtitle": "Inserisci la tua email e ti invieremo un link per reimpostare la password.",
  "auth.lastName": "Cognome",
  "auth.login": "Accedi",
  "auth.loginSubtitle": "Bentornato! Inserisci i tuoi dati.",
  "auth.loginToSmartMixinDescription": "Accedi a SmartMixin per raggiungere le tue stazioni meteo, consultare le analisi e gestire la tua dashboard meteo personale.",
  "auth.logout": "Esci",
  "auth.logoutConfirmation": "Vuoi uscire?",
  "auth.noAccountYet": "Non hai ancora un account?",
  "auth.or": "o",
  "auth.password": "Password",
  "auth.passwordReset": "Reset password",
  "auth.passwordResetSuccess": "La tua password è stata aggiornata con successo.",
  "auth.register": "Registrati",
  "auth.registerDescription": "Crea un account SmartMixin gratuito per collegare le tue stazioni meteo, monitorare i dati meteorologici e accedere a potenti strumenti di analisi.",
  "auth.registerSubtitle": "Crea il tuo account per iniziare.",
  "auth.restorePassword": "Ripristina password",
  "auth.restorePasswordSuccess": "Ti abbiamo appena inviato un link per la reimpostazione della password all'indirizzo {emailAddress} con ulteriori istruzioni.",
  "auth.sendReset": "Invia istruzioni di ripristino",
  "auth.signInWithApple": "Accedi con Apple",
  "auth.socialAccount": "o usa il tuo account",
  "auth.staffVerificationCode": "Codice di verifica",
  "auth.staffVerificationExpiresIn": "Verificato. Scade tra {duration}.",
  "auth.staffVerificationInvalidCode": "Codice errato. Riprova.",
  "auth.staffVerificationLoginAsStopped": "Login As è stato interrotto: inserisci un codice di verifica nella schermata Debug per continuare.",
  "auth.staffVerificationNotEnrolled": "Nessuna app di autenticazione è configurata per il tuo account. Aggiungine una nelle impostazioni di sicurezza del back office.",
  "auth.staffVerificationPrompt": "Inserisci il codice a 6 cifre della tua app di autenticazione, o un codice di recupero, per usare Login As e la ricerca utenti.",
  "auth.staffVerificationSetupLink": "Aggiungi un'app di autenticazione",
  "auth.staffVerificationSubmit": "Verifica",
  "auth.staffVerificationTitle": "Verifica del personale",
  "calendar.afternoon": "Pomeriggio",
  "calendar.april": "Aprile",
  "calendar.august": "Agosto",
  "calendar.changePeriod": "Periodo: {period}. Cambia periodo",
  "calendar.currentDay": "Oggi",
  "calendar.dateFormat": "Formato data",
  "calendar.day": "Giorno",
  "calendar.december": "Dicembre",
  "calendar.durationHours": "{hours} h",
  "calendar.durationHoursMinutes": "{hours} h {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.earlierYears": "Anni precedenti",
  "calendar.endTime": "Fine",
  "calendar.evening": "Sera",
  "calendar.february": "Febbraio",
  "calendar.goToNextDay": "Giorno successivo",
  "calendar.goToNextMonth": "Mese successivo",
  "calendar.goToNextWeek": "Settimana successiva",
  "calendar.goToNextYear": "Anno successivo",
  "calendar.goToPreviousDay": "Giorno precedente",
  "calendar.goToPreviousMonth": "Mese precedente",
  "calendar.goToPreviousWeek": "Settimana precedente",
  "calendar.goToPreviousYear": "Anno precedente",
  "calendar.hour": "Ora",
  "calendar.hoursCount": "{count, plural, one {# ora} other {# ore}}",
  "calendar.hoursShort": "h",
  "calendar.hoursShortCount": "{count, plural, one {# h} other {# h}}",
  "calendar.january": "Gennaio",
  "calendar.july": "Luglio",
  "calendar.june": "Giugno",
  "calendar.last12Hours": "Ultime 12 ore",
  "calendar.last24Hours": "Ultime 24 ore",
  "calendar.last30Days": "Ultimi 30 giorni",
  "calendar.last3Hours": "Ultime 3 ore",
  "calendar.last6Hours": "Ultime 6 ore",
  "calendar.last7Days": "Ultimi 7 giorni",
  "calendar.lastHour": "Ultima ora",
  "calendar.laterYears": "Anni successivi",
  "calendar.march": "Marzo",
  "calendar.max": "Max",
  "calendar.may": "Maggio",
  "calendar.month": "Mese",
  "calendar.monthTotal": "Totale mensile",
  "calendar.morning": "Mattina",
  "calendar.nextHours": "Prossime ore",
  "calendar.night": "Notte",
  "calendar.november": "Novembre",
  "calendar.october": "Ottobre",
  "calendar.oneDay": "1 giorno",
  "calendar.oneHour": "1 ora",
  "calendar.oneMonth": "1 mese",
  "calendar.oneWeek": "1 settimana",
  "calendar.periodRangeSpoken": "dal {start} al {end}",
  "calendar.previous24Hours": "Le 24 ore precedenti",
  "calendar.previous30Days": "I 30 giorni precedenti",
  "calendar.previous7Days": "I 7 giorni precedenti",
  "calendar.previousDay": "Il giorno precedente",
  "calendar.previousHours": "Ore precedenti",
  "calendar.previousMonth": "Il mese precedente",
  "calendar.previousWeek": "La settimana precedente",
  "calendar.previousYear": "L'anno precedente",
  "calendar.sameDayLastYear": "Lo stesso giorno dell'anno scorso",
  "calendar.sameMonthLastYear": "Lo stesso mese dell'anno scorso",
  "calendar.selectADate": "Seleziona una data",
  "calendar.selectAggregation": "Seleziona il valore visualizzato",
  "calendar.selectAMonth": "Seleziona un mese",
  "calendar.selectAYear": "Seleziona un anno",
  "calendar.selectGranularity": "Livello di dettaglio",
  "calendar.selectPeriod": "Seleziona un periodo",
  "calendar.september": "Settembre",
  "calendar.sixHours": "6 ore",
  "calendar.startTime": "Inizio",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 ore",
  "calendar.timezone": "Fuso orario",
  "calendar.today": "Oggi",
  "calendar.untilChanged": "Fino al cambiamento",
  "calendar.untilTime": "Fino a {time}",
  "calendar.untilTodayAt": "Fino a oggi alle {time}",
  "calendar.untilTomorrowAt": "Fino a domani alle {time}",
  "calendar.use24HourFormat": "Usa il formato 24h",
  "calendar.week": "Settimana",
  "calendar.year": "Anno",
  "calendar.yearToDate": "Da inizio anno",
  "calendar.yesterday": "Ieri",
  "charts.averageOverThePeriod": "Media nel periodo",
  "charts.calendarView": "Visualizzazione calendario",
  "charts.charts": "Grafici",
  "charts.chartView": "Visualizzazione grafico",
  "charts.comparison": "Confronto",
  "charts.customizeComparisonMetrics": "Personalizza le metriche di confronto",
  "charts.customizeComparisonMetricsDescription": "Trascina gli elementi per riordinare le tue metriche di confronto. Tocca l'icona dell'occhio per mostrare o nascondere le metriche.",
  "charts.loading": "Caricamento del grafico",
  "charts.maxOverThePeriod": "Massimo nel periodo",
  "charts.measureToDisplay": "Misura da visualizzare",
  "charts.minMaxRange": "Min. / Max.",
  "charts.noDataForThisPeriod": "Nessun dato nel periodo",
  "charts.observations": "Osservazioni",
  "charts.observedTemperature": "Temperatura osservata",
  "charts.seriesTableDate": "Data",
  "charts.showComparison": "Mostra confronto",
  "charts.stationComparison": "Confronto tra stazioni",
  "charts.stationComparisonDescription": "Confronta i dati meteorologici storici con un'altra stazione",
  "charts.sumOverThePeriod": "Cumulato nel periodo",
  "charts.tableLabel": "Tabella: {chart}",
  "charts.toggleSeries": "Mostra o nascondi {series}",
  "charts.viewAsChart": "Grafico",
  "charts.viewAsList": "Elenco",
  "charts.viewAsPeriods": "Periodi",
  "charts.viewAsTable": "Tabella",
  "charts.viewLabel": "Vista: {chart}",
  "common.add": "Aggiungi",
  "common.altitude": "Altitudine",
  "common.analysis": "Analisi",
  "common.average": "Media",
  "common.back": "Indietro",
  "common.backToHome": "Torna alla Home",
  "common.cancel": "Annulla",
  "common.cannotBeEmpty": "Questo campo non può essere vuoto.",
  "common.close": "Chiudi",
  "common.dailyForecast": "Previsioni giornaliere",
  "common.default": "Predefinito",
  "common.delete": "Elimina",
  "common.details": "Dettagli",
  "common.edit": "Modifica",
  "common.exitFullscreen": "Esci da schermo intero",
  "common.forecast": "Previsione",
  "common.frequency": "Frequenza",
  "common.full": "Completo",
  "common.fullscreen": "Schermo intero",
  "common.help": "Aiuto",
  "common.hidden": "Nascosti",
  "common.high": "Alto",
  "common.iDontKnowYet": "Non lo so ancora",
  "common.indoor": "Interno",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Ultimo aggiornamento",
  "common.low": "Basso",
  "common.maximum": "Massimo",
  "common.medium": "Medio",
  "common.minimum": "Minimo",
  "common.more": "Altro",
  "common.moreInformation": "Più informazioni",
  "common.next": "Avanti",
  "common.no": "No",
  "common.noAccountNeeded": "Nessun account necessario",
  "common.noItemsAvailable": "Nessun elemento disponibile",
  "common.notNow": "Non ora",
  "common.now": "Adesso",
  "common.openSettings": "Apri impostazioni",
  "common.outdoor": "Esterno",
  "common.pageNotFound": "Pagina non trovata",
  "common.pageNotFoundDescription": "La pagina che stai cercando non esiste o è stata spostata.",
  "common.rain": "Pioggia",
  "common.reorderCancel": "Spostamento annullato: {item}. Di nuovo in posizione {position} di {count}.",
  "common.reorderEnd": "Elemento rilasciato: {item}. Posizione {position} di {count}.",
  "common.reorderInstructions": "Per spostare questo elemento, premi Spazio o Invio, scegli la sua posizione con le frecce su e giù, poi premi di nuovo Spazio o Invio per rilasciarlo, oppure Esc per annullare.",
  "common.reorderOver": "{item}: ora in posizione {position} di {count}.",
  "common.reorderStart": "Elemento preso: {item}. Posizione {position} di {count}.",
  "common.share": "Condividi",
  "common.shareImageFailed": "Impossibile condividere l'immagine",
  "common.shareYourWeather": "Condividi il tuo meteo",
  "common.skip": "Salta",
  "common.start": "Inizia",
  "common.unknown": "Sconosciuto",
  "common.validate": "Conferma",
  "common.validEmail": "È richiesto un indirizzo email valido.",
  "common.very_low": "Molto basso",
  "common.weatherObservations": "Osservazioni meteorologiche",
  "common.welcome": "Benvenuto in SmartMixin!",
  "common.wind": "Vento",
  "common.yes": "Sì",
  "common.zoomImage": "Ingrandisci immagine",
  "compass.E": "E",
  "compass.E_long": "Est",
  "compass.ENE": "ENE",
  "compass.ENE_long": "Est-Nord-Est",
  "compass.ESE": "ESE",
  "compass.ESE_long": "Est-Sud-Est",
  "compass.N": "N",
  "compass.N_long": "Nord",
  "compass.NE": "NE",
  "compass.NE_long": "Nord-Est",
  "compass.NNE": "NNE",
  "compass.NNE_long": "Nord-Nord-Est",
  "compass.NNW": "NNO",
  "compass.NNW_long": "Nord-Nord-Ovest",
  "compass.NW": "NO",
  "compass.NW_long": "Nord-Ovest",
  "compass.S": "S",
  "compass.S_long": "Sud",
  "compass.SE": "SE",
  "compass.SE_long": "Sud-Est",
  "compass.SSE": "SSE",
  "compass.SSE_long": "Sud-Sud-Est",
  "compass.SSW": "SSO",
  "compass.SSW_long": "Sud-Sud-Ovest",
  "compass.SW": "SO",
  "compass.SW_long": "Sud-Ovest",
  "compass.W": "O",
  "compass.W_long": "Ovest",
  "compass.WNW": "ONO",
  "compass.WNW_long": "Ovest-Nord-Ovest",
  "compass.WSW": "OSO",
  "compass.WSW_long": "Ovest-Sud-Ovest",
  "dashboard.currentObservations": "Osservazioni attuali",
  "dashboard.currentRainEvent": "Evento di pioggia in corso",
  "dashboard.currentWeatherConditions": "Condizioni attuali",
  "dashboard.customizeDashboard": "Personalizza",
  "dashboard.customizeDashboardDescription": "Trascina gli elementi per riordinare la tua dashboard. Tocca l'icona dell'occhio per mostrare o nascondere le sezioni.",
  "dashboard.dashboard": "Home",
  "dashboard.dayRangeExpected": "{value} previsti alle {time}",
  "dashboard.dayRangeReached": "{value} alle {time}",
  "dashboard.dayRangeSteady": "Stabile a {value} tutto il giorno",
  "dashboard.hiddenSensors": "Sensori nascosti",
  "dashboard.hideSensor": "Nascondi {sensor}",
  "dashboard.lastRainEvent": "Ultimo evento di pioggia",
  "dashboard.lastVisibleSensor": "Almeno un sensore deve restare visibile.",
  "dashboard.manageSensors": "Gestisci sensori",
  "dashboard.manageSensorsDescription": "Trascina gli elementi per riordinare i sensori. Tocca l'icona dell'occhio per mostrare o nascondere i sensori. Tocca un nome per rinominarlo.",
  "dashboard.manageSensorsDescriptionWeb": "Fai clic sulla matita per rinominare un sensore, trascina la sua maniglia per riordinare l'elenco e fai clic sull'occhio per nasconderlo o mostrarlo.",
  "dashboard.moveSensor": "Sposta {sensor}",
  "dashboard.pressureSummary": "Sintesi della pressione",
  "dashboard.rainEvents": "Eventi di pioggia",
  "dashboard.rainSummary": "Riepilogo pioggia",
  "dashboard.renameSensor": "Rinomina {sensor}",
  "dashboard.shareOutdoorMeasures": "Condividi le tue misure esterne",
  "dashboard.shareOutdoorMeasuresDescription": "Partecipa alla community SmartMixin rendendo visibili agli altri le tue misure esterne. Le misure interne non saranno mai condivise.",
  "dashboard.showSensor": "Mostra {sensor}",
  "dashboard.temperatureSummary": "Riepilogo temperatura",
  "dashboard.useDefaultSensorName": "Usa il nome predefinito",
  "dashboard.windSummary": "Sintesi del vento",
  "devices.batteryLevel": "Livello batteria",
  "devices.firmwareVersion": "Versione firmware",
  "devices.moduleCount": "{count, plural, one {# modulo} other {# moduli}}",
  "devices.moduleType": "Tipo di modulo",
  "devices.noNetatmoWeatherStationYet": "Non possiedi ancora una stazione meteo Netatmo.",
  "devices.noOutdoorModule": "Nessun modulo esterno funzionante per questa stazione.",
  "devices.notReachable": "Non raggiungibile",
  "devices.serialNumber": "Numero di serie",
  "devices.signalAverage": "Medio",
  "devices.signalBad": "Debole",
  "devices.signalGood": "Buono",
  "devices.signalStrength": "Potenza del segnale",
  "devices.signalUnknown": "Sconosciuto",
  "devices.visitNetatmoWebsite": "Visita il sito di Netatmo",
  "devices.wifiStrength": "Potenza Wi-Fi",
  "forecastMaps.addColor": "Aggiungi colore",
  "forecastMaps.addLayer": "Aggiungi livello",
  "forecastMaps.autoDescription": "Il migliore disponibile per questa vista",
  "forecastMaps.autoDescriptionFree": "Gli account gratuiti usano {model}",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.autoSwitched": "Ora è mostrato {model}: {previous} copre il {coverage, number, percent} di questa vista",
  "forecastMaps.backToMaps": "Torna alle mappe",
  "forecastMaps.build": "Genera",
  "forecastMaps.buildCompleted": "Generazione completata",
  "forecastMaps.builderMetaDescription": "Componi mappe di previsione personalizzate dai livelli dei modelli meteo.",
  "forecastMaps.builderTitle": "Editor di mappe",
  "forecastMaps.buildFailed": "La generazione non è riuscita. Riprova.",
  "forecastMaps.buildNotPossible": "Questa mappa non può ancora essere generata — nessun dato di previsione disponibile.",
  "forecastMaps.buildProgress": "Rendering… {completed}/{total} passaggi",
  "forecastMaps.buildStarting": "Avvio della generazione…",
  "forecastMaps.byModel": "Per modello",
  "forecastMaps.byZone": "Per zona",
  "forecastMaps.colormap": "Mappa colori",
  "forecastMaps.colormapCustom": "Colori personalizzati",
  "forecastMaps.colormapGroupDomain": "Preset meteo",
  "forecastMaps.colormapGroupMatplotlib": "Preset scientifici",
  "forecastMaps.colorStop": "Colore {position}",
  "forecastMaps.configUnavailable": "Questa mappa di previsione non è disponibile. Al suo posto viene mostrata {name}.",
  "forecastMaps.contourLevels": "Livelli di contorno",
  "forecastMaps.countryCanada": "Canada",
  "forecastMaps.countryFrance": "Francia",
  "forecastMaps.countryGermany": "Germania",
  "forecastMaps.countryItaly": "Italia",
  "forecastMaps.countryScandinavia": "Scandinavia",
  "forecastMaps.countrySpain": "Spagna",
  "forecastMaps.countrySwitzerland": "Svizzera",
  "forecastMaps.countryUnitedStates": "Stati Uniti",
  "forecastMaps.coverageUnknown": "Zona sconosciuta",
  "forecastMaps.coversView": "Copre il {coverage, number, percent} di questa vista",
  "forecastMaps.customColormapMinColors": "Una mappa colori personalizzata richiede almeno due colori",
  "forecastMaps.customExtent": "Estensione personalizzata",
  "forecastMaps.displayName": "Nome visualizzato",
  "forecastMaps.downscaling": "Fattore di diradamento delle barbe",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Disegna area",
  "forecastMaps.east": "Est",
  "forecastMaps.extentDrawHint": "Trascina sulla mappa per disegnare l'area",
  "forecastMaps.extentInvalid": "L'ovest deve essere minore dell'est e il sud minore del nord",
  "forecastMaps.frameTime": "Ora della previsione",
  "forecastMaps.height": "Altezza (pollici)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.inThisArea": "In questa zona",
  "forecastMaps.invalidHexColor": "Colore non valido — usa #RRGGBB",
  "forecastMaps.layerHasErrors": "Questo livello contiene errori",
  "forecastMaps.layers": "Livelli",
  "forecastMaps.layerTypeBarbs": "Barbe del vento",
  "forecastMaps.layerTypeContour": "Linee di contorno",
  "forecastMaps.layerTypeFilledContour": "Contorni pieni",
  "forecastMaps.layerTypeMagnitude": "Magnitudine",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Campo vettoriale",
  "forecastMaps.leave": "Esci",
  "forecastMaps.levelsCount": "Numero",
  "forecastMaps.levelsInvalid": "Livelli di contorno non validi",
  "forecastMaps.levelsModeArange": "Passo fisso",
  "forecastMaps.levelsModeExplicit": "Valori espliciti",
  "forecastMaps.levelsModeLinspace": "Spaziatura uniforme (numero)",
  "forecastMaps.levelsStep": "Passo",
  "forecastMaps.levelsValues": "Valori",
  "forecastMaps.levelsValuesHint": "Separati da virgole, crescenti",
  "forecastMaps.loadingMaps": "Caricamento mappe…",
  "forecastMaps.localTimeHint": "Mostrato nella tua ora locale",
  "forecastMaps.lockedConfig": "{model} è un modello Premium. Al suo posto viene mostrato {fallback}.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Descrizione",
  "forecastMaps.mapName": "Nome della mappa",
  "forecastMaps.mapNameRequired": "Inserisci un nome",
  "forecastMaps.mapSettings": "Impostazioni mappa",
  "forecastMaps.maxLayersReached": "Questa mappa ha raggiunto il massimo di {max} livelli.",
  "forecastMaps.maxValue": "Valore massimo",
  "forecastMaps.memoryBudgetExceeded": "La risoluzione supera il budget di rendering — riduci i DPI o l'altezza",
  "forecastMaps.memoryBudgetUsage": "Budget di rendering: {percent}%",
  "forecastMaps.metaDescription": "Mappe di previsione animate generate dai modelli meteorologici.",
  "forecastMaps.metric": "Misura",
  "forecastMaps.metricRequired": "Seleziona una misura",
  "forecastMaps.metricUnavailable": "Non disponibile per questo modello",
  "forecastMaps.minBelowMax": "Il minimo deve essere inferiore al massimo",
  "forecastMaps.minMaxRequired": "I valori minimo e massimo sono obbligatori per questo tipo di livello",
  "forecastMaps.minValue": "Valore minimo",
  "forecastMaps.modelChipAuto": "Auto · {model}",
  "forecastMaps.modelCoversView": "{model} copre il {coverage, number, percent} di questa vista",
  "forecastMaps.modelNoRun": "Nessuna esecuzione completata al momento",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.moveLayerDown": "Sposta giù",
  "forecastMaps.moveLayerUp": "Sposta su",
  "forecastMaps.nanClipToMin": "Limita al minimo",
  "forecastMaps.nanMask": "Maschera",
  "forecastMaps.nanPolicy": "Dati mancanti",
  "forecastMaps.nanSkip": "Ignora",
  "forecastMaps.noCompletedRun": "Questa mappa non è ancora stata generata. Ricontrolla a breve.",
  "forecastMaps.noLayers": "Nessun livello. Aggiungi un livello per iniziare.",
  "forecastMaps.noMapsAvailable": "Non sono ancora disponibili mappe di previsione.",
  "forecastMaps.north": "Nord",
  "forecastMaps.opacity": "Opacità",
  "forecastMaps.openAsAnimation": "Apri come animazione",
  "forecastMaps.otherAreas": "Altre zone",
  "forecastMaps.outsideArea": "Non copre questa zona",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pausa",
  "forecastMaps.play": "Riproduci",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Impossibile caricare la previsione per questo punto.",
  "forecastMaps.pointValueLoading": "Caricamento previsione…",
  "forecastMaps.pointValueUnavailable": "Nessun dato per questo orario.",
  "forecastMaps.premiumModelForView": "{model} copre questa vista",
  "forecastMaps.premiumRequired": "Le mappe di previsione richiedono Premium",
  "forecastMaps.preview": "Anteprima",
  "forecastMaps.previewEmptyHint": "Configura almeno un livello valido per generare un'anteprima.",
  "forecastMaps.previewFailed": "L'anteprima non è riuscita",
  "forecastMaps.previewHour": "Ora di previsione",
  "forecastMaps.previewRendering": "Rendering dell'anteprima…",
  "forecastMaps.projection": "Proiezione",
  "forecastMaps.projectionLambertConformal": "Lambert conforme",
  "forecastMaps.projectionMercator": "Mercatore",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografica",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Nord America",
  "forecastMaps.removeColor": "Rimuovi colore",
  "forecastMaps.removeLayer": "Rimuovi livello",
  "forecastMaps.retry": "Riprova",
  "forecastMaps.run": "Run: {run}",
  "forecastMaps.runNotDisplayable": "Questa run non può essere mostrata sulla mappa interattiva.",
  "forecastMaps.save": "Salva",
  "forecastMaps.selectExtentOnMap": "Seleziona l'area sulla mappa",
  "forecastMaps.showArea": "Mostra zona",
  "forecastMaps.showAreaOf": "Mostra zona, {model}",
  "forecastMaps.south": "Sud",
  "forecastMaps.switchToModel": "Passa a {model}",
  "forecastMaps.title": "Mappe di previsione",
  "forecastMaps.uMetric": "Componente U",
  "forecastMaps.unitConversion": "Conversione di unità",
  "forecastMaps.unitNone": "Nessuna",
  "forecastMaps.unsavedChangesBody": "Hai modifiche non salvate. Uscire e scartarle?",
  "forecastMaps.unsavedChangesTitle": "Modifiche non salvate",
  "forecastMaps.useCurrentView": "Usa la vista corrente",
  "forecastMaps.useModelDomain": "Disattivato: viene usato l'intero dominio del modello",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Le misure U e V devono essere diverse",
  "forecastMaps.valueAtMapCentre": "Valore al centro della mappa",
  "forecastMaps.valueBetween": "Deve essere compreso tra {min} e {max}",
  "forecastMaps.variable": "Variabile",
  "forecastMaps.variableMissing": "{variable} non disponibile",
  "forecastMaps.variableOnlyFrom": "{variable} proviene solo da {model}",
  "forecastMaps.viewMap": "Vedi mappa",
  "forecastMaps.vMetric": "Componente V",
  "forecastMaps.west": "Ovest",
  "forecastMaps.windAnimation": "Animazione del vento",
  "forecastModels.addForecastModel": "Aggiungi un modello",
  "forecastModels.atYourStations": "Disponibili alle tue stazioni",
  "forecastModels.comparisonLoadError": "Impossibile caricare il confronto dei modelli meteo",
  "forecastModels.coverageLoading": "Calcolo di quali stazioni copre ogni modello…",
  "forecastModels.description_AROME": "Modello ad alta risoluzione di Météo France con risoluzione della convezione sull’Europa occidentale a 1,3 km. Il migliore della categoria per le previsioni a breve termine in Francia; aggiornato ogni tre ore.",
  "forecastModels.description_ARPEGE_EU": "Il dominio annidato europeo del modello ARPEGE di Météo France con risoluzione di 10 km. Previsioni a medio termine sull’Europa, aggiornate quattro volte al giorno.",
  "forecastModels.description_ARPEGE_GLOBAL": "Modello globale di previsione numerica del tempo di Météo France con risoluzione di 25 km, fino a circa 4 giorni. Aggiornato quattro volte al giorno.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI di DMI: modello a convezione esplicita sull'Europa nord-occidentale — Danimarca, Benelux, Irlanda, Regno Unito e Scandinavia — con risoluzione di 2 km fino a 60 ore, aggiornato otto volte al giorno. Contiene dati aperti DMI modificati (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Global Deterministic Prediction System (Sistema globale di previsione deterministica) di Environment Canada: modello mondiale a medio termine con risoluzione di 15 km fino a 10 giorni, aggiornato due volte al giorno.",
  "forecastModels.description_EC_HRDPS": "Sistema Deterministico di Previsione ad Alta Risoluzione di Environment Canada: modello a convezione esplicita sul Canada e sul nord degli Stati Uniti con risoluzione di 2,5 km fino a 48 ore, aggiornato quattro volte al giorno.",
  "forecastModels.description_EC_RDPS": "Sistema Regionale Deterministico di Previsione di Environment Canada: modello a medio termine sul Nord America con risoluzione di 10 km, aggiornato quattro volte al giorno.",
  "forecastModels.description_ECMWF_HRES": "Il modello di punta ad alta risoluzione (IFS) del Centro europeo per le previsioni meteorologiche a medio termine, ampiamente considerato il miglior sistema di previsione globale al mondo. Copre l'intero pianeta con una risoluzione di 25 km fino a 15 giorni, aggiornato quattro volte al giorno. Contiene dati aperti ECMWF modificati (CC BY 4.0).",
  "forecastModels.description_GFS": "Il modello globale di punta a medio termine della NOAA. Copre l’intero pianeta con risoluzione di 25 km fino a 16 giorni, aggiornato quattro volte al giorno.",
  "forecastModels.description_HRRR_CONUS": "Il High-Resolution Rapid Refresh della NOAA: modello con risoluzione della convezione sugli Stati Uniti continentali a 3 km, aggiornato ogni ora. Il più adatto per previsioni a brevissimo termine di temporali e maltempo.",
  "forecastModels.description_ICON": "Il modello globale ICON del DWD con risoluzione di 13 km che copre l'intero pianeta fino a 7,5 giorni, aggiornato quattro volte al giorno. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I di ItaliaMeteo, gestito insieme ad ARPAE: modello a convezione esplicita sull'Italia con risoluzione di 2,2 km fino a 72 ore, aggiornato due volte al giorno. Contiene dati aperti ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "Il run di controllo ICON-CH1-EPS di MeteoSwiss: modello a convezione esplicita sulle Alpi con risoluzione di 1 km fino a 33 ore, aggiornato ogni tre ore.",
  "forecastModels.description_ICON_CH2": "Il run di controllo ICON-CH2-EPS di MeteoSwiss: modello a convezione esplicita sulle Alpi — Svizzera e regione alpina circostante — con risoluzione di 2,1 km fino a 120 ore, aggiornato quattro volte al giorno.",
  "forecastModels.description_ICON_DE": "Modello ad alta risoluzione di DWD con risoluzione della convezione sulla Germania e i Paesi limitrofi a 2,2 km. Previsioni a breve termine aggiornate due volte al giorno. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Il dominio annidato europeo del modello ICON di DWD con risoluzione di 7 km che copre Europa e Nord Atlantico. Previsioni a medio termine aggiornate quattro volte al giorno. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Il servizio di previsioni meteorologiche aperto dell’Istituto Meteorologico Norvegese, che combina modelli nordici ad alta risoluzione con i dati ECMWF per fornire previsioni mondiali fino a 10 giorni in anticipo.",
  "forecastModels.description_MF_AROME_ANTILLES": "Dominio annidato di AROME sulle Antille francesi (Guadalupa, Martinica) con risoluzione di 2,5 km. Previsioni a breve termine aggiornate quattro volte al giorno.",
  "forecastModels.description_MF_AROME_GUYANE": "Dominio annidato di AROME sulla Guyana francese con risoluzione di 2,5 km. Previsioni a breve termine aggiornate quattro volte al giorno.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Dominio annidato di AROME sulla Nuova Caledonia con risoluzione di 2,5 km. Previsioni a breve termine aggiornate quattro volte al giorno.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Dominio annidato di AROME sulla Polinesia francese con risoluzione di 2,5 km. Previsioni a breve termine aggiornate quattro volte al giorno.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Dominio annidato di AROME su Riunione e Mayotte con risoluzione di 2,5 km. Previsioni a breve termine aggiornate quattro volte al giorno.",
  "forecastModels.description_RRFS_CONUS": "Il Rapid Refresh Forecast System della NOAA sugli Stati Uniti continentali a 3 km di risoluzione. Previsioni orarie aggiornate otto volte al giorno, fino a 84 ore nelle quattro esecuzioni principali e 18 ore nelle altre.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "Il Rapid Refresh Forecast System della NOAA che copre tutto il Nord America a 13 km di risoluzione. Previsioni orarie fino a 84 ore, aggiornate quattro volte al giorno.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "Previsione di punta di SmartMixin. Per ogni ora nella tua posizione, scegliamo il miglior modello disponibile — in genere un modello regionale ad alta risoluzione dove ce n’è uno (AROME in Francia, ICON-D2 in Germania, HRRR negli Stati Uniti, ARPEGE Europe in tutto il continente…) e altrove ripieghiamo su un modello globale — quindi colmiamo eventuali lacune con fonti vicine. Il risultato è una singola previsione fluida che copre qualsiasi punto del mondo fino a 14 giorni, aggiornata automaticamente ogni volta che uno dei modelli sottostanti viene aggiornato.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Previsione globale proprietaria di Weatherflow che combina più modelli numerici di previsione con osservazioni dalla sua rete di stazioni meteorologiche Tempest. Orizzonte mondiale di 10 giorni.",
  "forecastModels.everywhereElse": "Ovunque altrove",
  "forecastModels.everywhereElseFoot": "Usato in ogni stazione che i tuoi modelli preferiti non raggiungono.",
  "forecastModels.everywhereElsePick": "Scegline uno",
  "forecastModels.fallbackBlend": "Miscela SmartMixin",
  "forecastModels.fallbackBlendSub": "Combina più modelli, ciascuno dove è più forte.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES ovunque arrivi.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "Il modello globale della NOAA. Quello che oggi usano tutti gli account.",
  "forecastModels.fallbackResolution": "Risoluzione più alta",
  "forecastModels.fallbackResolutionSub": "La maglia più fine disponibile in ogni stazione.",
  "forecastModels.forecastChipLabelWithRun": "{model}, run {run}",
  "forecastModels.forecastChipRunHint": "Tieni premuto per mostrare o nascondere l’ultimo run",
  "forecastModels.forecastComparisonDescription": "Confronta facilmente i dati di previsione da diverse fonti meteo",
  "forecastModels.forecastFollowingPreferences": "Secondo le tue preferenze",
  "forecastModels.forecastLoadError": "Impossibile caricare le previsioni",
  "forecastModels.forecastModel": "Modello di previsione",
  "forecastModels.forecastModelAbout": "Informazioni su {model}",
  "forecastModels.forecastModelComparison": "Confronto dei modelli meteo",
  "forecastModels.forecastModelCoverage": "Copertura",
  "forecastModels.forecastModelDescription": "Descrizione",
  "forecastModels.forecastModels": "Modelli di previsione",
  "forecastModels.forecastModelScopeGlobal": "Globale",
  "forecastModels.forecastModelScopeGlobalDescription": "Questo modello copre l’intero pianeta.",
  "forecastModels.forecastModelScopeRegional": "Regionale",
  "forecastModels.forecastModelScopeRegionalDescription": "Questo modello copre solo una regione specifica.",
  "forecastModels.forecastModelSpecifications": "Specifiche",
  "forecastModels.forecastNoPinLocation": "Nessun modello preferito raggiunge questa località — decide «ovunque altrove».",
  "forecastModels.forecastNoPinStation": "Nessun modello preferito raggiunge questa stazione — decide «ovunque altrove».",
  "forecastModels.forecastNoPreferredModels": "Nessun modello preferito impostato.",
  "forecastModels.forecastOverrideElsewhere": "Le tue preferenze valgono ovunque altrove.",
  "forecastModels.forecastPickForLocation": "Oppure scegline uno per questa località",
  "forecastModels.forecastPickForStation": "Oppure scegline uno per questa stazione",
  "forecastModels.forecastPinWinsLocation": "{model} — il primo modello preferito che raggiunge questa località.",
  "forecastModels.forecastPinWinsStation": "{model} — il primo modello preferito che raggiunge questa stazione.",
  "forecastModels.forecastServedNowHere": "Al momento qui è {model}",
  "forecastModels.forecastSetForLocation": "Impostato per questa località",
  "forecastModels.forecastSetForStation": "Impostato per questa stazione",
  "forecastModels.forecastSettingsRowSub": "Modelli preferiti e cosa vale ovunque altrove",
  "forecastModels.forecastStopUsingHere": "Non usare più qui",
  "forecastModels.forecastUseForLocation": "Usa {model} per questa località",
  "forecastModels.forecastUseForStation": "Usa {model} per questa stazione",
  "forecastModels.forecastUsePreferred": "Usa i miei modelli preferiti",
  "forecastModels.frequencyHourly": "Ogni ora",
  "forecastModels.horizon": "Orizzonte",
  "forecastModels.horizonValue": "fino a {value} ore",
  "forecastModels.meshSize": "Dimensione griglia",
  "forecastModels.pickerShowAll": "Mostra l'intero catalogo",
  "forecastModels.pickerUnreachable": "{count, plural, one {# altro modello non raggiunge} other {# altri modelli non raggiungono}} nessuna delle tue stazioni",
  "forecastModels.pinInUse": "In uso",
  "forecastModels.pinShadowed": "Mai usato — un modello sopra copre tutte le tue stazioni",
  "forecastModels.pinSlots": "{used} di {max} · scegli un modello",
  "forecastModels.pinSlotsFull": "{max, plural, one {L’unico posto è occupato. Rimuovi il suo modello per aggiungerne un altro.} other {Tutti i # posti sono occupati. Rimuovine uno per aggiungerne un altro.}}",
  "forecastModels.pinsUncoveredCount": "{used} delle tue {count, plural, one {# stazione} other {# stazioni}}: nessun modello preferito {used, plural, one {la raggiunge} other {le raggiunge}} — decide «ovunque altrove».",
  "forecastModels.pinsUncoveredNamed": "{stations}: nessun modello preferito {count, plural, one {la raggiunge} other {le raggiunge}} — decide «ovunque altrove».",
  "forecastModels.pinUnreachable": "Mai usato — non raggiunge nessuna delle tue stazioni",
  "forecastModels.pinUsedAt": "Usato a {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Usato alla tua stazione} other {Usato in tutte le # stazioni}}",
  "forecastModels.pinUsedAtSome": "Usato in {used} di {count, plural, one {# stazione} other {# stazioni}}",
  "forecastModels.preferredModels": "Modelli preferiti",
  "forecastModels.preferredModelsAll": "Un elenco, tutte le stazioni",
  "forecastModels.preferredModelsOne": "Un elenco, valido ovunque",
  "forecastModels.publisher": "Editore",
  "forecastModels.removePreferredModel": "Rimuovi {model} dai tuoi modelli preferiti",
  "forecastModels.resetForecastPreference": "Reimposta",
  "forecastModels.resetForecastPreferenceHint": "Cancella i tuoi modelli preferiti e torna all'impostazione predefinita di SmartMixin.",
  "forecastModels.servedNowMany": "In questo momento: GFS {count, plural, one {alla tua stazione} other {in tutte le # stazioni}}.",
  "forecastModels.servedNowNone": "In questo momento: GFS ovunque.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodello",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Previsione Weatherflow",
  "forecastModels.weatherForecastModels": "Modelli di previsioni meteorologiche",
  "helpCenter.articleCount": "{count, plural, one {# articolo} other {# articoli}}",
  "helpCenter.articleNotFound": "Articolo non trovato",
  "helpCenter.articleNotFoundDescription": "L'articolo che stai cercando non esiste.",
  "helpCenter.backToHelpCenter": "Torna al centro assistenza",
  "helpCenter.browseByCategory": "Sfoglia per categoria",
  "helpCenter.categoryNotFound": "Categoria non trovata",
  "helpCenter.categoryNotFoundDescription": "Questa categoria non esiste o non contiene articoli.",
  "helpCenter.contactSupport": "Contatta il supporto",
  "helpCenter.feedbackHelpsImprove": "I tuoi commenti ci aiutano a migliorare i nostri articoli di assistenza.",
  "helpCenter.feedbackReasonNotAnswer": "Non risponde alla mia domanda",
  "helpCenter.feedbackReasonOutdated": "Le informazioni non sono aggiornate",
  "helpCenter.feedbackReasonUnclear": "Le istruzioni non sono chiare",
  "helpCenter.feedbackWhatWentWrong": "Qual è stato il problema?",
  "helpCenter.helpCategoryAccount": "Account",
  "helpCenter.helpCategoryBilling": "Fatturazione",
  "helpCenter.helpCategoryForecast": "Previsioni",
  "helpCenter.helpCategoryGettingStarted": "Per iniziare",
  "helpCenter.helpCategoryProviders": "Fornitori",
  "helpCenter.helpCategoryStations": "Stazioni",
  "helpCenter.helpCategoryTroubleshooting": "Risoluzione problemi",
  "helpCenter.helpCenter": "Centro assistenza",
  "helpCenter.landingDescription": "Trova risposte alle domande più comuni e scopri come ottenere il massimo da SmartMixin.",
  "helpCenter.linkToSection": "Link a questa sezione",
  "helpCenter.menuItemDescription": "FAQ e guide",
  "helpCenter.minRead": "{minutes} min di lettura",
  "helpCenter.onThisPage": "In questa pagina",
  "helpCenter.platformMobileApp": "App mobile",
  "helpCenter.platformMobileOnly": "Solo nell'app mobile",
  "helpCenter.platformWebApp": "App web",
  "helpCenter.platformWebOnly": "Solo nell'app web",
  "helpCenter.popularArticles": "Articoli più letti",
  "helpCenter.relatedArticles": "Articoli correlati",
  "helpCenter.searchArticles": "Cerca articoli...",
  "helpCenter.stillNeedHelp": "Hai ancora bisogno di aiuto?",
  "helpCenter.stillNeedHelpDescription": "Se questo articolo non ha risposto alla tua domanda, sarò lieto di aiutarti direttamente.",
  "helpCenter.supportEmailSubject": "Assistenza SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "Assistenza SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "Grazie per il tuo feedback!",
  "helpCenter.wasArticleHelpful": "Questo articolo ti è stato utile?",
  "intro.locationDescription": "Attiva l'accesso alla posizione per ottenere previsioni meteo precise adattate alla tua esatta area — niente più comunicati generici.",
  "intro.locationTitle": "Previsioni create per te",
  "intro.notificationDescription": "Attiva le notifiche per ricevere avvisi tempestivi sui cambiamenti meteorologici che contano per te — pioggia, neve o condizioni severe, proprio quando serve.",
  "intro.notificationsTitle": "Non perdere nessun cambiamento meteo",
  "intro.readyDescription": "Goditi previsioni precise, informazioni meteo in tempo reale e dati dalle stazioni di tutto il mondo — tutto in un’unica potente app.",
  "intro.readyTitle": "Sei pronto!",
  "intro.welcomeDescription": "Ricevi previsioni iperlocali dalle migliori agenzie meteorologiche — più accesso a oltre 40.000 stazioni meteo in tutto il mondo per vedere le condizioni reali, passate e presenti.",
  "intro.welcomeTitle": "Il tuo meteo, reinventato",
  "landing.alsoAvailableOn": "Disponibile anche su:",
  "landing.featureAlertsDescription": "Imposta soglie personalizzate per qualsiasi metrica. Ricevi notifiche quando la temperatura scende, inizia a piovere o si alza il vento.",
  "landing.featureAlertsTitle": "Avvisi intelligenti",
  "landing.featureAnalyticsDescription": "Grafici interattivi, analisi delle tendenze e statistiche dettagliate. Approfondisci i dati di temperatura, umidità, pressione, pioggia e vento.",
  "landing.featureAnalyticsTitle": "Analisi avanzate",
  "landing.featureExportDescription": "Ricevi tutti i tuoi dati meteo via email in un foglio di calcolo Excel, pronto per ulteriori analisi in Excel, Google Sheets o i tuoi strumenti preferiti.",
  "landing.featureExportTitle": "Esporta i tuoi dati",
  "landing.featureForecastDescription": "Accedi a {count, plural, one {#+ modello previsionale professionale} other {#+ modelli previsionali professionali}} tra cui ECMWF, GFS e modelli regionali. Confrontali fianco a fianco per fare le tue previsioni.",
  "landing.featureForecastTitle": "Confronta i modelli previsionali",
  "landing.featureHistoryDescription": "Accedi ai dati storici con scala oraria, giornaliera e mensile. Esportali in Excel per ricerche o archivi personali.",
  "landing.featureHistoryTitle": "Storico completo",
  "landing.featureMultiBrandDescription": "Collega Netatmo, Davis, Tempest, Ecowitt, Ambient Weather e altro. Basta passare da un'app all'altra.",
  "landing.featureMultiBrandTitle": "Tutti i marchi, un'unica app",
  "landing.featuresSubtitle": "SmartMixin ti offre gli strumenti per analizzare, confrontare e comprendere i tuoi dati meteo come un professionista.",
  "landing.featuresTitle": "Creato per gli amanti dei dati",
  "landing.finalCtaButton": "Crea account gratuito",
  "landing.finalCtaSubtitle": "Unisciti a migliaia di appassionati di meteo che si fidano di SmartMixin.",
  "landing.finalCtaTitle": "Pronto ad approfondire i tuoi dati meteo?",
  "landing.heroCta": "Inizia gratis",
  "landing.heroDescription": "Analisi approfondite, grafici eleganti e previsioni professionali — tutte le tue stazioni meteo riunite in un'unica potente app.",
  "landing.heroSecondaryCta": "Esplora la mappa",
  "landing.heroTagline": "Per gli appassionati di meteo",
  "landing.heroTitle": "Guarda il tuo meteo come mai prima",
  "landing.pricingComparisonCaption": "Confronto delle funzionalità dei piani gratuito e Premium",
  "landing.pricingFeatureAdvancedMetrics": "Metriche avanzate",
  "landing.pricingFeatureAlerts": "Avvisi personalizzati",
  "landing.pricingFeatureColumn": "Funzionalità",
  "landing.pricingFeatureExport": "Esportazione dati (Excel)",
  "landing.pricingFeatureForecastComparison": "Confronto previsioni",
  "landing.pricingFeatureForecasts": "Modelli di previsione",
  "landing.pricingFeatureForecastsFreeTier": "1 modello",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ modello} other {#+ modelli}}",
  "landing.pricingFeatureReports": "Analisi e report",
  "landing.pricingFeatureStationComparison": "Confronto tra stazioni",
  "landing.pricingFeatureWidgets": "Widget schermata principale",
  "landing.pricingFeatureYearOverYear": "Analisi anno su anno",
  "landing.pricingFreeCta": "Inizia",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Più popolare",
  "landing.pricingPremiumCta": "Inizia",
  "landing.pricingPremiumDescription": "Da 1,99 €/mese — abbonati su web, App Store o Google Play",
  "landing.pricingSubtitle": "Inizia gratis, passa a Premium quando hai bisogno di più potenza.",
  "landing.pricingTitle": "Prezzi semplici e trasparenti",
  "landing.statBrands": "Marchi supportati",
  "landing.statForecasts": "Modelli di previsione",
  "landing.statStations": "Stazioni meteorologiche",
  "landing.supportedDevicesNote": "E in più oltre {count, number} stazioni pubbliche della rete dell’Organizzazione Meteorologica Mondiale",
  "landing.supportedDevicesSubtitle": "Collega la tua stazione meteo esistente in pochi minuti. Supportiamo {count, plural, one {# marchio principale} other {# marchi principali}} e altri in arrivo.",
  "landing.supportedDevicesTitle": "Funziona con la tua stazione",
  "metrics.absolutePressure": "Pressione assoluta",
  "metrics.airDensity": "Densità dell'aria",
  "metrics.airGap": "Distanza d'aria",
  "metrics.apparentTemperature": "Temperatura apparente",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Media",
  "metrics.avg_wind": "Vento medio",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Temp. globo nero",
  "metrics.boilerOn": "Caldaia ON",
  "metrics.boilerOnInHours": "Caldaia ON (ore)",
  "metrics.cloudCover": "Nuvolosità",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Conducibilità",
  "metrics.dailyPrecipitation": "Precipitazione giornaliera",
  "metrics.dailyRain": "Pioggia giornaliera",
  "metrics.degreeDayShort": "GG",
  "metrics.depth": "Profondità",
  "metrics.depthSensors": "Sensori di profondità",
  "metrics.dewPoint": "Punto di rugiada",
  "metrics.distance": "Distanza",
  "metrics.downTrend": "Tendenza al ribasso",
  "metrics.ET": "Evapotraspirazione",
  "metrics.etToday": "ET oggi",
  "metrics.feelsLike": "Percepita",
  "metrics.feelsLikeWithFormula": "Percepita ({formula})",
  "metrics.frostPoint": "Punto di brina",
  "metrics.gust": "Raffica",
  "metrics.gustDirection": "Direzione della raffica",
  "metrics.hail": "Grandine",
  "metrics.heatIndex": "Indice di calore",
  "metrics.heatingDegreeDays": "Gradi giorno di riscaldamento",
  "metrics.heatingPower": "Potenza di riscaldamento",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Umidità",
  "metrics.lastLightningImpact": "Ultima fulminazione",
  "metrics.lastMeasure": "Ultima misura",
  "metrics.leafSensors": "Sensore umidità fogliare",
  "metrics.leafWetness": "Umidità fogliare",
  "metrics.lightningDistance": "Distanza",
  "metrics.lightningStrikeCount": "Conteggio dei fulmini",
  "metrics.lightningStrikeDistance": "Distanza del fulmine",
  "metrics.max": "Max.",
  "metrics.max_gust": "Raffica max.",
  "metrics.maxToday": "Max. oggi",
  "metrics.min": "Min.",
  "metrics.noise": "Rumore",
  "metrics.normalizedHeatingCoefficient": "Coefficiente di riscaldamento normalizzato",
  "metrics.outdoorTemperature": "Temperatura esterna",
  "metrics.PM_1": "PM 1",
  "metrics.PM_10": "PM 10",
  "metrics.PM_2P5": "PM 2,5",
  "metrics.precipitation": "Precipitazioni",
  "metrics.pressure": "Pressione",
  "metrics.rain": "Pioggia",
  "metrics.rainDurationValue": "Durata della pioggia: {duration}",
  "metrics.rainfallMeasurement": "Misurazione delle precipitazioni",
  "metrics.rainRate": "Intensità di pioggia",
  "metrics.relativePressure": "Pressione relativa",
  "metrics.setPoint": "T° Impostata",
  "metrics.snow": "Neve",
  "metrics.snowfall": "Nevicata",
  "metrics.soilMoisture": "Umidità del suolo",
  "metrics.soilSensors": "Sensori suolo",
  "metrics.soilWaterTension": "Tensione idrica del suolo",
  "metrics.solarEnergy": "Energia solare",
  "metrics.solarRadiation": "Radiazione solare",
  "metrics.speed": "Velocità",
  "metrics.stableTrend": "Stabile",
  "metrics.sum": "Totale",
  "metrics.temperature": "Temperatura",
  "metrics.temperatureSensors": "Sensori di temperatura e umidità",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "Tendenza al rialzo",
  "metrics.uv": "UV",
  "metrics.visibility": "Visibilità",
  "metrics.weatherCondition": "Condizione meteorologica",
  "metrics.wetBulbGlobeTemperature": "Temperatura del globo a bulbo umido",
  "metrics.wetBulbTemperature": "Temp. bulbo umido",
  "metrics.wind": "Vento",
  "metrics.windChill": "Raffreddamento da vento",
  "metrics.windDirection": "Direzione del vento",
  "metrics.windMeasurement": "Misurazione del vento",
  "metrics.windRun": "Corsa del vento",
  "metrics.windRunDescription": "La corsa del vento è la distanza totale percorsa dal vento in un periodo di tempo",
  "metrics.windSpeed": "Velocità del vento",
  "navigation.allFavorites": "Mostra tutte",
  "navigation.breadcrumbs": "Percorso di navigazione",
  "navigation.collapseNavigation": "Comprimi navigazione",
  "navigation.expandNavigation": "Espandi navigazione",
  "navigation.main": "Principale",
  "navigation.mapShort": "Mappa",
  "navigation.skipToContent": "Vai al contenuto principale",
  "navigation.stationsShort": "Stazioni",
  "network.cancelError": "Richiesta cancellata",
  "network.connectionError": "Server non disponibile",
  "network.networkError": "Rete non disponibile",
  "network.serverError": "Qualcosa è andato storto...",
  "network.timeoutError": "Tempo di connessione scaduto",
  "network.unknownError": "Errore sconosciuto",
  "premium.alreadyPremium": "Hai già un account premium!",
  "premium.bestValue": "Miglior offerta",
  "premium.billingDetailsAndroid": "Prova gratuita: non ti verrà addebitato nulla se annulli almeno 24 ore prima della fine della prova. In seguito, il tuo abbonamento a SmartMixin si rinnova automaticamente, a meno che tu non lo annulli almeno 24 ore prima della fine del periodo in corso; puoi annullarlo in qualsiasi momento dalle impostazioni del tuo account Google Play. Ogni rinnovo viene addebitato al prezzo indicato sul pulsante qui sopra. Il pagamento viene addebitato sul tuo account Google Play alla conferma dell'acquisto e all'inizio di ogni periodo di rinnovo.",
  "premium.billingDetailsIos": "Prova gratuita: non ti verrà addebitato nulla se annulli almeno 24 ore prima della fine della prova. In seguito, il tuo abbonamento a SmartMixin si rinnova automaticamente, a meno che tu non lo annulli almeno 24 ore prima della fine del periodo in corso; puoi annullarlo in qualsiasi momento dalle impostazioni del tuo account App Store. Ogni rinnovo viene addebitato al prezzo indicato sul pulsante qui sopra. Il pagamento viene addebitato sul tuo account App Store alla conferma dell'acquisto e all'inizio di ogni periodo di rinnovo.",
  "premium.freeBannerBody": "Gli account gratuiti ricevono GFS ovunque: i tuoi modelli preferiti e «ovunque altrove» iniziano a funzionare nel momento in cui ti abboni.",
  "premium.freeBannerTitle": "Le preferenze si applicano con Premium",
  "premium.freeSubscription": "Abbonamento premium gratuito",
  "premium.freeTrialForPeriod": "Prova gratuita per {period, plural, one {# giorno} other {# giorni}}",
  "premium.getUnlimitedAccess": "Accesso illimitato a:",
  "premium.manageMySubscription": "Gestisci il mio abbonamento",
  "premium.notPurchasedYet": "Nessun acquisto di SmartMixin Premium trovato per questo account dello store.",
  "premium.orChooseMonthly": "Oppure scegli mensile:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Attivo",
  "premium.premiumAnnualTrialInfo": "Inizia con una prova gratuita di {days, plural, one {# giorno} other {# giorni}}",
  "premium.premiumCurrentPlan": "Piano attuale",
  "premium.premiumDownloadApp": "Scarica l'app per abbonarti:",
  "premium.premiumEndsOn": "Scade il {date}",
  "premium.premiumFeatureAlerts": "Allerte meteo",
  "premium.premiumFeatureAnalysis": "Analisi meteo avanzata",
  "premium.premiumFeatureCharts": "Confronti tra grafici",
  "premium.premiumFeatureExport": "Esportazione dati",
  "premium.premiumFeatureForecast": "Modelli di previsione regionali",
  "premium.premiumFeatureNotification": "Widget barra di stato",
  "premium.premiumFeatureTitle": "Funzione Premium",
  "premium.premiumFeatureWidgets": "Widget schermata principale",
  "premium.premiumFreePlan": "Gratuito",
  "premium.premiumInactive": "Non abbonato",
  "premium.premiumManageStoreSubscription": "Ti sei abbonato tramite {store}. Gestisci o annulla l’abbonamento da lì.",
  "premium.premiumManageWebSubscription": "Gestisci il tuo abbonamento, aggiorna il metodo di pagamento o annulla.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Rinnovo il {date}",
  "premium.premiumSubscribeAnnual": "Annuale — 9,99 €/anno",
  "premium.premiumSubscribedOn": "Abbonato su {platform}",
  "premium.premiumSubscribedOnWeb": "Abbonato sul web",
  "premium.premiumSubscribeMonthly": "Mensile — 1,99 €/mese",
  "premium.premiumSubscribeOnWeb": "Abbonati ora per sbloccare tutte le funzionalità premium.",
  "premium.premiumSubscriptionSuccess": "Il tuo abbonamento è stato attivato! Goditi tutte le funzionalità premium.",
  "premium.premiumSubscriptionSuccessTitle": "Benvenuto in Premium!",
  "premium.premiumWebappNotice": "L'abbonamento sul web non è disponibile al momento.",
  "premium.pricePerMonth": "{price}/mese",
  "premium.pricePerYear": "{price}/anno",
  "premium.purchasedNetatmoPro": "Hai già acquistato Netatmo Pro ({date}). Questo ti dà accesso a un sottoinsieme di funzionalità premium. Iscriviti a una delle seguenti offerte se desideri avere accesso a tutte le funzionalità premium.",
  "premium.purchaseFailed": "Non è stato possibile completare l'acquisto. Riprova.",
  "premium.restoreFailed": "Non è stato possibile ripristinare i tuoi acquisti. Riprova.",
  "premium.restorePurchase": "Ripristina acquisto",
  "premium.savingsPercent": "Risparmia {percent}%",
  "premium.seePremium": "Scopri Premium",
  "premium.startFreeTrial": "Inizia prova gratuita",
  "premium.storeUnavailable": "Lo store non è disponibile al momento. Riprova più tardi.",
  "premium.subscribeNow": "Abbonati ora — senza prova",
  "premium.switchToPremium": "Passa a SmartMixin Premium",
  "premium.thenPrice": "poi {price}",
  "providerHints.ambientWeatherApiKey": "Creata nelle impostazioni del tuo account ambientweather.net.",
  "providerHints.davisApiSecret": "Mostrato solo una volta alla creazione della chiave API V2 — conservalo al sicuro.",
  "providerHints.davisV2ApiKey": "Dalla pagina delle chiavi API V2 di weatherlink.com.",
  "providerHints.ecowittApi": "Dalla pagina API del tuo account Ecowitt.",
  "providerHints.ecowittApp": "La chiave dell'applicazione, anch'essa dal tuo account Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Usa email e password del tuo account My AcuRite — non l'accesso SmartMixin.",
  "providerHints.myAcuriteEmail": "L'email del tuo account My AcuRite — non il tuo accesso SmartMixin.",
  "providerHints.myAcuritePassword": "La password del tuo account My AcuRite.",
  "providerHints.weatherflowToken": "Token a uso personale da tempestwx.com → impostazioni → autorizzazioni dati.",
  "providerHints.wundergroundEditKey": "Usa un'altra chiave",
  "providerHints.wundergroundKey": "Una stringa lunga dalla pagina delle chiavi API del tuo account Weather Underground — non la tua password di wunderground.com.",
  "providerHints.wundergroundKeyExample": "es. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Chiave API verificata",
  "providerHints.wundergroundNoStationsNearby": "Nessuna stazione trovata vicino a questa posizione. Prova a inserire direttamente un ID stazione.",
  "providerHints.wundergroundStationIdExample": "es. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Ottieni la tua chiave API Ambient Weather.",
  "providerIntro.davisStep2": "Ottieni la tua chiave API V2 e segreto API Davis.",
  "providerIntro.ecowittStep2": "Ottieni la tua chiave API e chiave applicazione Ecowitt.",
  "providerIntro.getStarted": "Inizia",
  "providerIntro.myAcuriteStep2": "Usa email e password del tuo account My AcuRite esistente.",
  "providerIntro.netatmoEnergyStep2": "Accedi a Netatmo quando richiesto — nessuna chiave API necessaria.",
  "providerIntro.netatmoWeatherStep2": "Accedi a Netatmo quando richiesto — nessuna chiave API necessaria.",
  "providerIntro.signupBanner": "Ci siamo quasi — crea il tuo account gratuito SmartMixin per collegare {provider}.",
  "providerIntro.step1": "Accedi al tuo account SmartMixin (NON al login {provider}).",
  "providerIntro.step3EmailPassword": "Inseriscili qui.",
  "providerIntro.step3KeyOrToken": "Incollalo qui.",
  "providerIntro.step3OAuth": "Autorizza SmartMixin nella finestra che appare.",
  "providerIntro.step3Wunderground": "Incolla la tua chiave API, poi seleziona una stazione vicina o inserisci qualsiasi ID stazione.",
  "providerIntro.stepOfTotal": "Passo {step} di {total}",
  "providerIntro.title": "Collegare {provider}",
  "providerIntro.weatherflowStep2": "Ottieni il tuo token Tempest a uso personale.",
  "providerIntro.wundergroundBrowsePublic": "Non hai una stazione? Sfoglia quelle pubbliche",
  "providerIntro.wundergroundFindNearby": "Trova stazioni vicino a me",
  "providerIntro.wundergroundOrEnterId": "Oppure inserisci un ID stazione",
  "providerIntro.wundergroundStep2": "Ottieni la tua chiave API Weather Underground. Potrai poi collegare qualsiasi stazione — la tua o una pubblica.",
  "reports.agroMeteorology": "Agrometeorologia",
  "reports.analysis": "Analisi",
  "reports.annualCumulativeRainfallComparison": "Confronto precipitazioni annuali cumulative",
  "reports.annualHeatingDurationComparison": "Confronto annuale della durata di riscaldamento",
  "reports.annualHeatingEfficiency": "Efficienza di riscaldamento annuale",
  "reports.annualIndoorComparison": "Comparazione annuale modulo interno",
  "reports.annualOutdoorComparison": "Comparazione annuale modulo esterno",
  "reports.annualOutdoorReport": "Riepilogo annuale modulo esterno",
  "reports.annualReport": "Riepilogo annuale",
  "reports.annualSolarReport": "Rapporto solare annuale",
  "reports.annualWaterBalance": "Bilancio idrico annuale",
  "reports.annualWaterBalanceCarryOver": "Riporto {year} ({value})",
  "reports.annualWaterBalanceDescription": "Il bilancio idrico (versione semplificata, vengono utilizzate solo pioggia ed evapotraspirazione) aiuta a gestire l'approvvigionamento idrico",
  "reports.avgHumidity": "Umidità media",
  "reports.avgMaxTemperature": "Media T°max",
  "reports.avgMetric": "Media – {metric}",
  "reports.avgMinTemperature": "Media T°min",
  "reports.avgPressure": "Pressione media",
  "reports.avgTemperature": "Temperatura media",
  "reports.chartsAndTable": "Grafici e tabella",
  "reports.climateNormalPeriodOfRecord": "Periodo di osservazione ({years, plural, one {# anno} other {# anni}})",
  "reports.climateNormals": "Normali climatiche",
  "reports.climateNormalStandardLabel": "Normale standard ({period})",
  "reports.climateTrendPerDecade": "Tendenza della temperatura: {value} per decennio su {years, plural, one {# anno} other {# anni}}",
  "reports.coldestMonthRanking": "{month} più freddo mai registrato",
  "reports.comfortable": "Comfort (45% {lessThan} Umidità ≤ 60%)",
  "reports.cumulativeRainfall": "Precipitazioni cumulative",
  "reports.cumulativeRainfallDescription": "Monitora le precipitazioni totali cumulate nel periodo selezionato.",
  "reports.dailyMaxRainfall": "Max precipitazione giornaliera",
  "reports.dataExport": "Esportazione dati",
  "reports.dataExportXlsxFormatDescription": "Esporta tutti i dati della tua stazione in formato Excel (* .xlsx). Dopo aver fatto clic sul pulsante, dopo pochi minuti riceverai un'email con i dati elaborati.",
  "reports.daysOfData": "{days, plural, one {# giorno} other {# giorni}} di dati",
  "reports.daysWithFrost": "Giorni di gelo",
  "reports.daysWithHeavyRain": "Giorni di pioggia intensa (≥ {threshold})",
  "reports.daysWithoutThaw": "Giorni senza disgelo",
  "reports.daysWithStrongFrost": "Giorni di grande gelo",
  "reports.emailSent": "Ti è stata inviata un'email",
  "reports.frostDays": "Giorni di gelo",
  "reports.grasslandTemperatureSum": "Somma temperatura prati",
  "reports.grasslandTemperatureSumDescription": "Ripresa sostenibile della vegetazione quando la somma raggiunge {threshold}",
  "reports.growingDegreeDays": "Gradi giorno di crescita",
  "reports.highPressure": "Anticiclone (Pressione media ≥ {threshold})",
  "reports.iceDays": "Giorni di ghiaccio",
  "reports.indoorReport": "Riepilogo modulo interno",
  "reports.keyFacts": "Dati chiave",
  "reports.longestDrySpell": "Periodo secco più lungo",
  "reports.longestRunOfRainyDays": "Serie più lunga di giorni di pioggia",
  "reports.longestRunWithoutRun": "Serie più lunga di giorni senza pioggia",
  "reports.longestWetSpell": "Periodo piovoso più lungo",
  "reports.lowPressure": "Bassa pressione (Pressione media {lessThan} {threshold})",
  "reports.maxHumidity": "Umidità massima",
  "reports.maxMetric": "Massimo – {metric}",
  "reports.maxPressure": "Pressione massima",
  "reports.maxTemperature": "Temperatura massima",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Escursione massima (/24H)",
  "reports.minHumidity": "Umidità minima",
  "reports.minMetric": "Minimo – {metric}",
  "reports.minPressure": "Pressione minima",
  "reports.minTemperature": "Temperatura minima",
  "reports.minTempMagnitude24h": "Escursione minima (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Ancora # giorno} other {Ancora # giorni}} questo mese",
  "reports.monthlyAverageCountdownDetail": "Allora compariranno la media del mese e la sua classifica.",
  "reports.monthlyAverageRule": "Le medie mensili e le classifiche compaiono quando un mese solare ha {days, plural, one {# giorno registrato} other {# giorni registrati}}.",
  "reports.monthlyHeatingEfficiency": "Efficienza riscaldamento mensile",
  "reports.monthlyOutdoorReport": "Riepilogo mensile modulo esterno",
  "reports.monthlyReport": "Riepilogo mensile",
  "reports.monthlySolarReport": "Rapporto solare mensile",
  "reports.monthlyWindReport": "Riepilogo mensile modulo vento",
  "reports.monthsOfData": "{months, plural, one {# mese} other {# mesi}} di dati",
  "reports.numberOfDays": "Numero di giorni",
  "reports.outdoorReport": "Riepilogo modulo esterno",
  "reports.overviewSection": "Panoramica",
  "reports.rainfall": "Precipitazioni",
  "reports.rainyDays": "Giorni di pioggia",
  "reports.recordClimatologicalDay": "Giorno climatologico (06–06 UTC)",
  "reports.recordClimDayBody": "Qui la pioggia è sommata per giorno di calendario, da mezzanotte a mezzanotte all’ora della stazione. I servizi meteorologici la sommano dalle 06:00 alle 06:00 UTC, quindi un temporale a cavallo della mezzanotte può rendere un altro giorno il più piovoso.",
  "reports.recordDailyRain": "Giorno più piovoso",
  "reports.recordFromHourlyReadings": "Dalle letture orarie",
  "reports.recordHigh": "Record di caldo",
  "reports.recordLow": "Record di freddo",
  "reports.recordOfficialBody": "Il servizio meteorologico pubblica per questa stazione una massima e una minima giornaliere, lette da termometri a massima e a minima. Colgono brevi picchi che le letture orarie non rilevano, quindi sostituiscono i valori ricavati dalle letture orarie.",
  "reports.recordOfficialValue": "Valore ufficiale",
  "reports.recordsAndClimatology": "Record e clima",
  "reports.recordSheetTitle": "Informazioni su questi record",
  "reports.recordsSince": "Record dal {date}",
  "reports.recordWindGust": "Raffica di vento più forte",
  "reports.relativelyWet": "Abbastanza umido (60 % {lessThan} Umidità ≤ 80 %)",
  "reports.sectionReportCount": "{count, plural, one {# rapporto} other {# rapporti}}",
  "reports.sendEmail": "Invia email",
  "reports.summerDays": "Giorni estivi",
  "reports.tableScrollRegion": "{title}, scorre orizzontalmente",
  "reports.tooDry": "Molto secco (Umidità ≤ 45%)",
  "reports.tooWet": "Molto umido (Umidità {greaterThan} 80%)",
  "reports.tropicalNights": "Notti tropicali",
  "reports.unlockPremiumSubtitle": "Incluso con SmartMixin Premium",
  "reports.unlockPremiumTitle": "Sblocca {count, plural, one {# funzione premium} other {# funzioni premium}}",
  "reports.warmestMonthRanking": "{month} più caldo mai registrato",
  "reports.waterBalance": "Bilancio idrico",
  "reports.yearsOfData": "{years, plural, one {# anno} other {# anni}} di dati",
  "reports.yearToDateTemperatureComparison": "Confronto delle temperature dall'inizio dell'anno",
  "sensors.bgtSensors": "Globo nero e WBGT",
  "sensors.cameraFeed": "Telecamera",
  "sensors.compareHumidity": "Confronta umidità",
  "sensors.compareMoisture": "Confronta umidità del suolo",
  "sensors.comparePm25": "Confronta PM2.5",
  "sensors.compareTemperatures": "Confronta temperature",
  "sensors.compareWaterTension": "Confronta tensione idrica del suolo",
  "sensors.depthByChannel": "Profondità per canale",
  "sensors.heatStressExtreme": "Stress termico estremo",
  "sensors.heatStressModerate": "Stress termico moderato",
  "sensors.heatStressNone": "Nessuno stress termico",
  "sensors.heatStressStrong": "Stress termico forte",
  "sensors.heatStressVeryStrong": "Stress termico molto forte",
  "sensors.indoorClimate": "Clima interno",
  "sensors.indoorCo2Levels": "Livelli di CO2",
  "sensors.indoorTemperatureAndHumidity": "Temperatura e umidità",
  "sensors.leafWetnessByChannel": "Umidità delle foglie per canale",
  "sensors.lightningSensor": "Fulmine",
  "sensors.moistureByChannel": "Umidità del suolo per canale",
  "sensors.noDataAvailable": "Nessun dato disponibile",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 per canale",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Seleziona canale",
  "sensors.sensorDetailDescription": "Visualizza i dati storici e le tendenze dei canali del sensore.",
  "sensors.sensorHistory": "Cronologia del sensore",
  "sensors.soilConductivityByChannel": "Conducibilità per canale",
  "sensors.soilTemperatureByChannel": "Temperatura del suolo per canale",
  "sensors.strikesToday": "Fulmini oggi",
  "sensors.temperatureByChannel": "Temperatura per canale",
  "sensors.viewChart": "Visualizza grafico",
  "sensors.waterTensionByChannel": "Tensione idrica del suolo per canale",
  "settings.appearance": "Aspetto",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabo",
  "settings.bulgarian": "bulgaro",
  "settings.catalan": "catalano",
  "settings.chartGestures": "Gesti sui grafici",
  "settings.chartGesturesDescription": "Lo scorrimento sui grafici cambia il periodo di tempo, pizzicando i grafici cambia la scala temporale",
  "settings.choiceCount": "{count, plural, one {# disponibile} other {# disponibili}}",
  "settings.contactUs": "Contattaci",
  "settings.contactUsDescription": "Ottieni aiuto o invia feedback",
  "settings.croatian": "croato",
  "settings.czech": "ceco",
  "settings.dailyDetailByPeriods": "Dettaglio giornaliero per periodi",
  "settings.dailyDetailByPeriodsDescription": "Raggruppa le 24 ore in notte, mattina, pomeriggio e sera — la stessa suddivisione usata dal riepilogo del giorno.",
  "settings.danish": "danese",
  "settings.dark": "Tema scuro",
  "settings.dataDisplay": "Visualizzazione dati",
  "settings.dateAndTime": "Data e ora",
  "settings.donateButton": "Fai una donazione",
  "settings.donateDescription": "SmartMixin è realizzato da un piccolo team. Se lo trovi utile, puoi sostenerne lo sviluppo con una donazione una tantum di qualsiasi importo. È un regalo — non cambia il tuo piano e non sblocca alcuna funzione.",
  "settings.donateSuccessBody": "La tua donazione aiuta a mantenere attivo SmartMixin e a migliorarlo. Te ne siamo davvero grati.",
  "settings.donateSuccessTitle": "Grazie per il tuo sostegno!",
  "settings.donateTitle": "Sostieni SmartMixin",
  "settings.dragToReorder": "Trascina per riordinare",
  "settings.dutch": "olandese",
  "settings.english": "inglese",
  "settings.french": "francese",
  "settings.german": "tedesco",
  "settings.gestures": "Gesti",
  "settings.greek": "greco",
  "settings.hungarian": "ungherese",
  "settings.italian": "italiano",
  "settings.japanese": "giapponese",
  "settings.korean": "coreano",
  "settings.language": "Lingua",
  "settings.languageDescription": "Lingua preferita",
  "settings.light": "Tema chiaro",
  "settings.measurementUnits": "Unità di misura",
  "settings.netatmoDashboard": "Dashboard Netatmo",
  "settings.netatmoLayoutCards": "Elenco di schede",
  "settings.netatmoLayoutCardsDescription": "Una scheda per modulo, tutto in un unico scorrimento",
  "settings.netatmoLayoutClassic": "Classico",
  "settings.netatmoLayoutClassicDescription": "Due schede, scorri tra i moduli",
  "settings.netatmoNewLayoutNotice": "Nuovo layout: una scheda per modulo.",
  "settings.netatmoSwitchBackToClassic": "Torna al classico",
  "settings.netatmoSwitchToLayout": "Passa a {layout}",
  "settings.norwegian": "norvegese",
  "settings.notificationsSection": "Notifiche",
  "settings.ongoingNotificationEnabled": "Attiva notifica permanente",
  "settings.ongoingNotificationMetrics": "Metriche visualizzate",
  "settings.ongoingNotificationPermissionRequired": "È richiesto il permesso per le notifiche",
  "settings.ongoingNotificationPreviewHint": "Anteprima: attiva il widget per mostrarlo",
  "settings.ongoingNotificationStatusBar": "Barra di stato",
  "settings.polish": "polacco",
  "settings.portuguese": "portoghese",
  "settings.preferencesSection": "Preferenze",
  "settings.privacyPolicy": "Informativa sulla privacy",
  "settings.russian": "russo",
  "settings.serbian": "serbo",
  "settings.settings": "Impostazioni",
  "settings.settingsPageTitle": "Impostazioni - {page}",
  "settings.slovak": "slovacco",
  "settings.smallDecimals": "Decimali piccoli",
  "settings.smallDecimalsDescription": "Mostra le cifre decimali in una dimensione più piccola",
  "settings.spanish": "spagnolo",
  "settings.statusBarWidget": "Widget barra di stato",
  "settings.statusBarWidgetDescription": "Dati meteo sempre visibili",
  "settings.subscriptionSection": "Abbonamento",
  "settings.supportSection": "Supporto",
  "settings.swedish": "svedese",
  "settings.systemTheme": "Tema di sistema",
  "settings.termsOfService": "Termini di servizio",
  "settings.themeDarkShort": "Scuro",
  "settings.themeLightShort": "Chiaro",
  "settings.themeSystemShort": "Sistema",
  "settings.turkish": "turco",
  "settings.ukrainian": "ucraino",
  "settings.units": "Unità",
  "settings.unitsDescription": "Unità di misura visualizzate all'interno dell'applicazione",
  "settings.update": "Aggiorna",
  "settings.windDirectionConvention": "Freccia direzione del vento",
  "settings.windDirectionConventionDescription": "Scegli come vengono visualizzate le frecce della direzione del vento",
  "settings.windDirectionMeteorological": "Direzione di origine",
  "settings.windDirectionMeteorologicalDescription": "La freccia indica da dove viene il vento (convenzione meteorologica)",
  "settings.windDirectionOceanographic": "Direzione del flusso",
  "settings.windDirectionOceanographicDescription": "La freccia indica dove soffia il vento (convenzione oceanografica)",
  "stations.addAStation": "Aggiungi stazione",
  "stations.addToFavorites": "Aggiungi ai preferiti",
  "stations.addYourOwnStation": "Aggiungi la tua stazione",
  "stations.clearRecentLocations": "Cancella tutto",
  "stations.clearSearch": "Cancella ricerca",
  "stations.currentLocation": "Posizione corrente",
  "stations.customizedStationName": "Nome personalizzato della stazione",
  "stations.favoriteLocations": "Preferiti",
  "stations.favoriteLocationsEmpty": "Puoi aggiungere fino a 5 posizioni preferite.",
  "stations.favoriteStations": "Stazioni preferite",
  "stations.filterStationDescription": "Non visualizzare stazioni con misure inaffidabili",
  "stations.filterStations": "Filtra stazioni",
  "stations.filterStationSourceDescription": "Seleziona i fornitori di stazioni che desideri visualizzare sulla mappa",
  "stations.findStationsNearYou": "Trova stazioni vicino a te",
  "stations.hiddenStations": "Stazioni nascoste",
  "stations.hiddenStationsDescription": "Puoi mostrare di nuovo una stazione toccando l'icona dell'occhio accanto ad essa.",
  "stations.hideStationNamed": "Nascondi {station}",
  "stations.lastSeen": "visto {time}",
  "stations.loadingStation": "Caricamento stazione…",
  "stations.location": "Località",
  "stations.locationAddedToFavorites": "Posizione aggiunta ai preferiti",
  "stations.locationNotGranted": "L'autorizzazione alla posizione non è concessa. Consenti l'accesso alla posizione nelle impostazioni del dispositivo.",
  "stations.locationRemovedFromFavorites": "Posizione rimossa dai preferiti",
  "stations.locations": "Località",
  "stations.locationUnavailable": "Impossibile rilevare la tua posizione. Controlla le impostazioni del dispositivo.",
  "stations.maxFavoriteLocationsReached": "Puoi avere solo fino a 5 luoghi preferiti. Rimuovi uno per aggiungerne un altro.",
  "stations.modifyFavoriteStations": "Modifica le stazioni preferite",
  "stations.modifyFavoriteStationsDescription": "Puoi riordinare le tue stazioni preferite trascinandole. Puoi anche rimuoverle dall'elenco.",
  "stations.myLocation": "La mia posizione",
  "stations.nearbyWeatherStations": "Stazioni meteorologiche vicine",
  "stations.noLocationsFound": "Nessuna località trovata",
  "stations.noLongerReported": "Non più presente",
  "stations.noLongerReportedBy": "Non più presente su {provider} dal {date}",
  "stations.noSearchResults": "Nessun articolo corrisponde alla ricerca",
  "stations.noStationsFound": "Nessuna stazione trovata",
  "stations.noWeatherStationYet": "Non possiedi ancora una stazione meteo",
  "stations.recentLocations": "Recenti",
  "stations.recentLocationsEmpty": "La tua cronologia recente è vuota.",
  "stations.removeFromFavorites": "Rimuovi dai preferiti",
  "stations.removeStationNamed": "Rimuovi {station} dai preferiti",
  "stations.reorderStationNamed": "Sposta {station}",
  "stations.searchForLocation": "Cerca una località",
  "stations.searchForWeatherStation": "Cerca una stazione meteo",
  "stations.searchResults": "Risultati di ricerca",
  "stations.searchResultsEmpty": "Nessun risultato trovato.",
  "stations.searchResultsFound": "{count, plural, one {# risultato trovato} other {# risultati trovati}}",
  "stations.searchStationsDescription": "Inserisci una città, un indirizzo o un nome di luogo per trovare stazioni meteo nelle vicinanze.",
  "stations.searchStationsHint": "Usa la barra di ricerca sopra per scoprire stazioni meteo in qualsiasi luogo del mondo.",
  "stations.selectStationForComparison": "Seleziona una stazione per il confronto",
  "stations.stationAddedToFavorites": "Stazione aggiunta ai preferiti",
  "stations.stationCount": "{count, plural, one {# stazione} other {# stazioni}}",
  "stations.stationInformation": "Informazioni sulla stazione",
  "stations.stationName": "Nome stazione",
  "stations.stationObservationsDescription": "Visualizza le ultime osservazioni delle stazioni meteorologiche",
  "stations.stationRemovedFromFavorites": "Stazione rimossa dai preferiti",
  "stations.stationsLoading": "Caricamento delle stazioni meteorologiche",
  "stations.stationsNear": "Stazioni vicino a {place}",
  "stations.stationType": "Tipo di stazione",
  "stations.statusOffline": "Offline",
  "stations.statusOnline": "Online",
  "stations.statusStale": "Obsoleto",
  "stations.tryAnotherLocation": "Non abbiamo trovato stazioni meteo vicino a questa posizione. Prova a cercare in un'altra zona.",
  "stations.unhideStationNamed": "Mostra di nuovo {station}",
  "stations.weatherStation": "Stazione meteorologica",
  "stations.weatherStationCount": "{count, plural, one {# stazione meteorologica} other {# stazioni meteorologiche}}",
  "stations.weatherStations": "Stazioni meteorologiche",
  "stations.welcomeConnectService": "Possiedi una stazione meteo? Collega il tuo servizio",
  "stations.welcomeSubtitle": "Il tuo meteo, tutto in un unico posto",
  "thermostat.away": "Fuori casa",
  "thermostat.boilerOn": "Caldaia ON",
  "thermostat.hg": "Protezione antigelo",
  "thermostat.homeInformation": "Informazioni sulla casa",
  "thermostat.homeName": "Nome casa",
  "thermostat.manualBoost": "Incremento manuale",
  "thermostat.manualSetpointUntil": "Impostazione manuale fino a",
  "thermostat.noThermostatYet": "Non possiedi ancora un termostato",
  "thermostat.relay": "Relè",
  "thermostat.room": "Stanza",
  "thermostat.rooms": "Stanze",
  "thermostat.smartThermostat": "Termostato intelligente",
  "thermostat.smartValve": "Valvola intelligente",
  "thermostat.whenBackHome": "Quando tornerai a casa?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Pollici",
  "units.inchOfMercury": "Pollici di mercurio",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Chilometri all'ora",
  "units.knot": "Nodi",
  "units.meterPerSecond": "Metri al secondo",
  "units.milePerHour": "Miglia orarie",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimetri",
  "units.millimeterOfMercury": "Millimetri di mercurio",
  "weatherConditions.blizzard": "Bufera di neve",
  "weatherConditions.blowingDust": "Polvere sollevata dal vento",
  "weatherConditions.blowingSnow": "Neve sollevata dal vento",
  "weatherConditions.breezy": "Brezza",
  "weatherConditions.clear": "Sereno",
  "weatherConditions.cloudy": "Nuvoloso",
  "weatherConditions.drizzle": "Pioviggine",
  "weatherConditions.flurries": "Deboli nevicate",
  "weatherConditions.foggy": "Nebbia",
  "weatherConditions.freezingDrizzle": "Pioviggine gelata",
  "weatherConditions.freezingRain": "Pioggia gelata",
  "weatherConditions.frigid": "Freddo intenso",
  "weatherConditions.hail": "Grandine",
  "weatherConditions.haze": "Caligine",
  "weatherConditions.heavyRain": "Pioggia intensa",
  "weatherConditions.heavySnow": "Neve intensa",
  "weatherConditions.hot": "Caldo",
  "weatherConditions.hurricane": "Uragano",
  "weatherConditions.isolatedThunderstorms": "Temporali isolati",
  "weatherConditions.mixedRainAndHail": "Pioggia e grandine",
  "weatherConditions.mostlyClear": "Prevalentemente sereno",
  "weatherConditions.mostlyCloudy": "Prevalentemente nuvoloso",
  "weatherConditions.mostlySunny": "Prevalentemente soleggiato",
  "weatherConditions.notAvailable": "Condizioni meteo non disponibili",
  "weatherConditions.partlyCloudy": "Parzialmente nuvoloso",
  "weatherConditions.rain": "Pioggia",
  "weatherConditions.rainSleet": "Pioggia e granelli di ghiaccio",
  "weatherConditions.rainSnow": "Pioggia e neve",
  "weatherConditions.scatteredShowers": "Rovesci sparsi",
  "weatherConditions.scatteredSnowShowers": "Rovesci di neve sparsi",
  "weatherConditions.scatteredThunderstorms": "Temporali sparsi",
  "weatherConditions.showers": "Rovesci",
  "weatherConditions.sleet": "Granelli di ghiaccio",
  "weatherConditions.smoke": "Fumo",
  "weatherConditions.snow": "Neve",
  "weatherConditions.snowShowers": "Rovesci di neve",
  "weatherConditions.strongStorms": "Temporali forti",
  "weatherConditions.sunny": "Soleggiato",
  "weatherConditions.thunderstorms": "Temporali",
  "weatherConditions.tornado": "Tornado",
  "weatherConditions.tropicalStorm": "Tempesta tropicale",
  "weatherConditions.windy": "Ventoso",
  "weatherConditions.wintryMix": "Precipitazioni invernali miste",
  "weatherMap.clusterMarkerName": "{metric} {value}, mediana di {count, plural, one {# stazione} other {# stazioni}}, ingrandisci",
  "weatherMap.legendHeavy": "Forte",
  "weatherMap.legendLight": "Leggera",
  "weatherMap.legendLightningHelp": "Il colore indica l'età di ogni fulmine negli ultimi {minutes} minuti — i più recenti in bianco, i più vecchi in rosso scuro.",
  "weatherMap.legendNewest": "Più recenti",
  "weatherMap.legendOldest": "Più vecchi",
  "weatherMap.legendStationsHelp": "Il colore del marcatore riflette il valore della metrica selezionata.",
  "weatherMap.lightningDataAttribution": "Dati sui fulmini: Blitzortung.org",
  "weatherMap.lightningStrikes": "Fulmini",
  "weatherMap.lightningStrikesDescription": "Mostra i fulmini in tempo reale sulla mappa",
  "weatherMap.mapLayers": "Livelli della mappa",
  "weatherMap.mapLegend": "Legenda della mappa",
  "weatherMap.mapMode": "Modalità mappa",
  "weatherMap.mapNameForecast": "Mappa di previsione, {model}, {variable}",
  "weatherMap.mapNameObservations": "Mappa meteo, osservazioni",
  "weatherMap.modeForecast": "Previsione",
  "weatherMap.modeObservations": "Osservazioni",
  "weatherMap.radarDataAttribution": "Dati radar: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.radarTime": "Ora del radar",
  "weatherMap.rainRadar": "Radar pioggia",
  "weatherMap.rainRadarDescription": "Visualizza la sovrapposizione del radar pioggia sulla mappa",
  "weatherMap.resetBearing": "Trascina per ruotare la mappa, fai clic per riorientarla a nord",
  "weatherMap.showingForecast": "Previsione mostrata: {model}, {variable}",
  "weatherMap.signInForecastBody": "Le mappe GFS sono gratuite con un account SmartMixin. Con Premium sono disponibili altri modelli.",
  "weatherMap.signInForecastTitle": "Accedi per vedere le mappe di previsione",
  "weatherMap.stationMarkerName": "{metric} {value}, una stazione",
  "weatherMap.stationMarkersHint": "Con i tasti freccia ti sposti tra le stazioni",
  "weatherMap.stationMarkerWindValue": "{speed}, da {direction}",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain è un'ulteriore fonte di dati fornita tramite il Tempest Weather System, basato sulla tecnologia Nearcast. I dati di NC Rain sono una stima dell'accumulo medio di precipitazioni attorno al tuo Tempest a livello di quartiere",
  "weatherMap.weatherMap": "Mappa meteo",
  "weatherMap.weatherMapMetaDescription": "SmartMixin offre mappe meteo interattive e radar pioggia per le condizioni meteorologiche in tutto il mondo.",
  "weatherMap.zoomIn": "Ingrandisci",
  "weatherMap.zoomOut": "Riduci",
  "weatherWarnings.activeNow": "In corso",
  "weatherWarnings.agencyMessage": "Messaggio del servizio meteorologico",
  "weatherWarnings.areaCovered": "Zona interessata",
  "weatherWarnings.areaThisLocation": "{area} (questa località)",
  "weatherWarnings.areaYourStation": "{area} (la tua stazione meteorologica)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Avviso ufficiale, {severity}: {hazard}} one {Avviso ufficiale, {severity}: {hazard}, e un altro} other {Avviso ufficiale, {severity}: {hazard}, e altri #}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Avviso ufficiale in arrivo, {severity}: {hazard}} one {Avviso ufficiale in arrivo, {severity}: {hazard}, e un altro} other {Avviso ufficiale in arrivo, {severity}: {hazard}, e altri #}}",
  "weatherWarnings.crumb": "Avvisi ufficiali",
  "weatherWarnings.emptyBody": "Il servizio meteorologico nazionale non ha avvisi in vigore per questo luogo. Ricontrolliamo ogni pochi minuti.",
  "weatherWarnings.emptyTitle": "Nessun avviso ufficiale",
  "weatherWarnings.ended": "Terminato",
  "weatherWarnings.endedAt": "Questo avviso è terminato {time}.",
  "weatherWarnings.errorBody": "Controlla la connessione. Riproviamo ogni pochi minuti.",
  "weatherWarnings.errorTitle": "Impossibile caricare gli avvisi ufficiali",
  "weatherWarnings.fromTime": "Da {time}",
  "weatherWarnings.hazardAirQuality": "Qualità dell'aria",
  "weatherWarnings.hazardAvalanche": "Valanghe",
  "weatherWarnings.hazardCoastalEvent": "Rischi costieri",
  "weatherWarnings.hazardFlood": "Alluvioni",
  "weatherWarnings.hazardFog": "Nebbia",
  "weatherWarnings.hazardForestFire": "Incendi boschivi",
  "weatherWarnings.hazardHighTemperature": "Temperature elevate",
  "weatherWarnings.hazardLowTemperature": "Basse temperature",
  "weatherWarnings.hazardOther": "Altro pericolo",
  "weatherWarnings.hazardRain": "Pioggia",
  "weatherWarnings.hazardSnowIce": "Neve e ghiaccio",
  "weatherWarnings.hazardThunderstorm": "Temporali",
  "weatherWarnings.hazardUv": "Radiazione UV",
  "weatherWarnings.hazardWind": "Vento",
  "weatherWarnings.hideHazards": "Nascondi fenomeni",
  "weatherWarnings.issuedBy": "Emesso da {sender}",
  "weatherWarnings.lastUpdate": "Ultimo aggiornamento: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Mappa della zona interessata: {area}.} other {Mappa delle # zone interessate. {area} è evidenziata.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Mappa della zona interessata.} other {Mappa delle # zone interessate.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Mappa non disponibile. La zona è elencata qui sotto.} other {Mappa non disponibile. Le # zone sono elencate qui sotto.}}",
  "weatherWarnings.moreHazards": "+ altri {count}: {hazards}",
  "weatherWarnings.notInLanguage": "Non disponibile in {language}. Mostrato come pubblicato dal servizio meteorologico.",
  "weatherWarnings.openOn": "Apri su {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # altra zona} other {+ altre # zone}}",
  "weatherWarnings.severityExtreme": "Estremo",
  "weatherWarnings.severityFrom": "{severity} da {time}",
  "weatherWarnings.severityMinor": "Lieve",
  "weatherWarnings.severityModerate": "Moderato",
  "weatherWarnings.severityNow": "{severity} ora",
  "weatherWarnings.severitySevere": "Grave",
  "weatherWarnings.severityUntil": "{severity} fino a {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Mostra # zona} other {Mostra tutte le # zone}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {Mostra # zona sulla mappa} other {Mostra tutte le # zone sulla mappa}}",
  "weatherWarnings.showHazards": "Mostra fenomeni",
  "weatherWarnings.showPeriods": "{count, plural, one {Mostra # periodo} other {Mostra tutti i # periodi}}",
  "weatherWarnings.source": "Fonte: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, poi {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# avviso meteo ufficiale} other {# avvisi meteo ufficiali}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Avvisi meteo ufficiali",
  "weatherWarnings.todayAt": "oggi alle {time}",
  "weatherWarnings.tomorrow": "Domani",
  "weatherWarnings.tomorrowAt": "domani alle {time}",
  "weatherWarnings.upcoming": "In arrivo",
  "weatherWarnings.viewAll": "Tutti gli avvisi ufficiali",
  "weatherWarnings.whatToDo": "Cosa fare"
}
